// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("microuniverso.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("microuniverso.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("microuniverso.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/logo-cliente.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/logo-microuniverso-login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/logo-microuniverso.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/logo-microuniverso-icone.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, h4 {
    margin: 0
}

body, a, .bootstrap-datetimepicker-widget table {
    color: var(--mu-texto, #333739)
}

kbd {
    display: inline-block;
    padding: 1px 6px;
    margin: 0 1px;
    font-family: inherit;
    font-size: 0.9em;
    font-weight: 600;
    line-height: 1.5;
    color: var(--mu-texto, #444);
    background-color: var(--mu-superficie-media, #e4e6e8);
    border: 1px solid var(--mu-borda-forte, #a9a9a9);
    border-radius: 3px;
    box-shadow: inset 0 -1px 0 var(--mu-borda-forte, #a9a9a9);
}

u {
    text-decoration-line: underline;
    text-decoration-color: var(--mu-azul-microuniverso-borda, #43A4D1);
    text-underline-offset: 0px;
    text-underline-position: under;
    filter: drop-shadow(1px 1px 1px var(--mu-sombra-decoracao, rgba(0, 0, 0, .3)));
}

/* Menu esquerdo "Endereços": com offset 0 (padrao do <u>) o sublinhado do
   atalho encosta no rabicho do "ç", mesmo com text-underline-position:under.
   So aqui afasta mais para o rabicho aparecer inteiro. */
#orcamento_menu_enderecos_react u {
    text-underline-offset: 3px;
}


::-webkit-scrollbar {
    width: 8px;
    height: 10px
}

::-webkit-scrollbar-button:end:increment,
::-webkit-scrollbar-button:start:decrement {
    display: none
}

::-webkit-scrollbar-track-piece {
    background-color: var(--mu-superficie-sutil, #f3f3f3);
    -webkit-border-radius: 0px
}

::-webkit-scrollbar-thumb {
    background-color: #3da3cd;
    -webkit-border-radius: 3px
}

.bootstrap-datetimepicker-widget {
    z-index: 1030;
}

body, html, h4 {
    font: 13px/1.54 arial, sans-serif
}

.corpo {
    display: table;
    width: 100%
}

p, h2, h3, .msg, .t2, fieldset, .submit {
    margin: 0 0 0.5em
}

dt, dd {
    font-weight: 400;
    line-height: inherit
}

.informacaoAdicional {
    color: whitesmoke;
    float: right;
    font-size: x-large;
    max-width: 60%;
    white-space: nowrap;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .informacaoAdicional {
        text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    }
}

@supports not (mix-blend-mode: screen) {
    .informacaoAdicional {
        text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    }
}

@supports (mix-blend-mode: screen) {
    .informacaoAdicional {
        mix-blend-mode: screen; /*difference; hard-light;*/
    }
}

@font-face {
    font-family: 'microuniverso';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype')
}

[class*="icone-"]:before {
    display: inline-block;
    margin: 0 8px 0 0;
    vertical-align: top;
}

[class*="fas"]:before {
    color: var(--mu-azul-texto, #3c8ac9);
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    margin: 0 8px 0 0;
}

[class*="fab"]:before {
    color: var(--mu-azul-texto, #3c8ac9);
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    margin: 0 8px 0 0;
}

[class*="icone-"]:empty:before {
    margin: 0
}

[class*="icone-"]:before, .migalha:after {
    -webkit-font-smoothing: antialiased;
    font: 20px/20px microuniverso;
}

.icone-menu:before {
    content: "m";
    margin: 0 2em 0 0
}

.icone-menu {
    color: #66696b;
    cursor: pointer;
}

    .icone-menu:hover {
        color: var(--mu-texto, #333739)
    }

.icone-excluir:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "a"
}

.icone-voltar:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "i"
}

.icone-erro:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "r"
}

.msg:before {
    background: var(--mu-superficie, #fff);
    border-radius: 50%
}

.icone-incluir:before {
    color: #5ac93c;
    content: "b"
}

.icone-ok:before {
    color: #5ac93c;
    content: "q"
}

.icone-check:before {
    color: var(--mu-texto-suave, #80888a);
    content: "p";
    margin: -1px 4px 0 -6px
}

.icone-check-blue:before {
    color: #0000FF;
    content: "p";
    margin: -1px 4px 0 -6px
}

.icone-pin:before {
    color: var(--mu-texto-suave, #80888a);
    content: "s";
    opacity: .2
}

.icone-pin.ativo:before {
    opacity: 1
}

.icone-vazio:before {
    opacity: 0;
}

.icone-acompanhamento:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "x"
}

.icone-imagem:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "y"
}

.icone-parcelas:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "u"
}

table {
    border-collapse: separate
}

*, *:before, *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.icone-conf:before {
    color: var(--mu-texto-suave, #80888a);
    content: "o"
}

.icone-selecionar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "g"
}

.icone-anterior:before, .icone-proximo:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "i"
}

.icone-alerta:before {
    color: #f6f610;
    content: "G"
}

.icone-alerta-critico:before {
    color: #ff0000;
    content: "G"
}

.icone-pagamento:before {
    color: #fcb404;
    content: "v"
}

.icone-proximo:before {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
}

.icone-credito:before {
    content: "1"
}

.icone-historico:before {
    content: "2"
}

.icone-meta:before {
    content: "3"
}

.icone-pagar:before {
    content: "4"
}

.icone-receber:before {
    content: "5"
}

.icone-disponivel:before {
    content: "6"
}

.icone-baixo:before {
    -webkit-transform: scale(-1, -1);
    content: "6";
    transform: scale(-1, -1);
}

.icone-calculo:before {
    content: "7"
}

.icone-compra:before {
    content: "8"
}

.icone-estoque:before {
    content: "9"
}

.icone-produtocheck:before {
    color: #66696b;
    content: "q"
}

.icone-cor:before {
    color: var(--mu-texto-suave, #80888a);
    content: "\\e902"
}

.icone-orcamento-historico:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "O"
}

.icone-orcamento-editar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "n"
}

.icone-orcamento-duplicar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "O"
}

.icone-orcamento-imagem:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "y"
}

.icone-reservar:before {
    color: #5ac93c;
    content: "V"
}

.icone-reservar-faltante:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "V"
}

.icone-cor-configurado:before {
    color: #2E978C;
    content: "\\e902"
}

.icone-cor-configurar:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "\\e902"
}

.icone-lido:before {
    content: "\\71";
    color: #00c800;
}

.icone-naolido:before {
    content: "\\71";
    color: var(--mu-texto-desab, #bbbbbb);
}

.icone-repetido:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e800"
}

.icone-repetido-vermelho:before {
    color: var(--mu-laranja-texto, #f25713);
    content: "\\e800"
}

.icone-incrementar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\4b"
}

.icone-inserir-novo:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\62"
}

.icone-email:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "A"
}

.ico-whatsapp:before {
    color: #25D366;
    content: "\\f232"
}

.icone-imprimir:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "B"
}

.icone-compartilhar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "C"
}

.icone-pesquisar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "c"
}

.icone-trocar-filial:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "C"
}

.icone-info:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "d"
}

.icone-comparar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "j"
}

.icone-editar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "n"
}

.icone-favorito:empty:before {
    color: #daddde;
    content: "l";
    margin: 3px 6px 0 0
}

.icone-favorito.ativo:before {
    color: var(--mu-laranja-texto, #f25713)
}

.icone-topo:before {
    -webkit-transform: rotate(90deg);
    color: #c5cacb;
    content: "i";
    transform: rotate(90deg)
}

.icone-separar:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "t"
}

.icone-opcoes:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "x"
}

.icone-seleciona:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "w"
}

header .icone-info:before {
    color: #daddde;
    float: right;
    margin: -1px 0 -1px 10px
}

.icone-sub:before {
    color: var(--mu-texto-suave, #80888a);
    content: "f"
}

.icone-sugerido:before {
    color: var(--mu-texto-suave, #80888a);
    content: "\\74";
}

.icone-itens:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\6b"
}

.icone-cotacoes-perdidas:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\54"
}

.icone-faturamento:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\56"
}

.icone-home:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e906"
}

.icone-office:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e907"
}

.icone-usuario:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e977"
}

.icone-markup:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "7";
}

.icone-pagamentos:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\76"
}

.icone-endereco:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e94e"
}

.icone-entrega:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e9b6"
}

.icone-resumo:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e928"
}

.icone-autorizado:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e97b"
}

.icone-finalizar-orcamento:before {
    color: #00c800;
    content: "\\ea17"
}

.icone2-frete-peso-cubagem-ativado:before {
    color: var(--mu-azul-texto, #3c8ac9);
}

.icone2-frete-peso-cubagem-desativado:before {
    color: var(--mu-texto-desab, #bbb);
}

.icone-descontos:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e936"
}

.icone-estrela-vazia:before {
    color: var(--mu-texto, #000000);
    content: "\\e9d7";
    font-size: small;
}

.icone-estrela-cheia:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "\\e9d9";
    font-size: small
}

li > a.icone-estrela-vazia:hover {
    opacity: 1
}

li > a.icone-estrela-vazia {
    float: right;
    padding: 0px !important;
    z-index: 0;
    top: -31px;
    width: 20px;
    opacity: 0.2;
}

li > a.icone-estrela-cheia {
    float: right;
    padding: 0px !important;
    z-index: 0;
    top: -31px;
    width: 20px;
    opacity: 1;
    box-shadow: none !important;
}

.btn-pin {
    width: 219px;
    transition: width 0.3s;
    position: fixed;
    height: 48px;
    bottom: 0;
    padding: 0 16px;
    border: 0;
    border-top: 1px solid var(--mu-borda-sutil, #e5e5e5);
    border-right: 1px solid var(--mu-borda-sutil, #e5e5e5);
    color: #707070;
    display: flex;
    align-items: center;
    background-color: var(--mu-superficie-sutil, #f2f2f2);
}

.icone-pin-fixo:before {
    content: '\\e905';
    float: left;
    font-size: 30px;
}

.icone-pin-suspenso:before {
    content: '\\e908';
    float: left;
    font-size: 30px;
}

.icone-expandido:before {
    color: var(--mu-texto, #000);
    content: '\\e98b';
    font-size: 15px;
}

.icone-comissoes:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: '\\eaf2';
    font-size: 15px;
}

h3 .icone-sub:empty:before {
    margin: 3px 8px 0 0
}

header .icone-sub:before {
    color: #daddde;
    position: absolute;
    right: -8px;
    top: -3px
}

.esconde:before {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.icone-lista:before {
    color: var(--mu-azul-texto, #3c8ac9);
    content: "e"
}

header .icone-lista:before {
    color: #fff;
    margin: 0 2em 0 0;
    opacity: .5
}

.icone-menu, header .icone-lista {
    float: left;
    overflow: hidden;
    padding: 19px;
    white-space: nowrap;
    width: 58px;
}

header .icone-lista {
    padding: 12px 19px
}

    header .icone-lista:hover:before {
        opacity: .75
    }

    header .icone-lista:focus:before {
        opacity: .75;
        border: 1px solid black;
    }

    header .icone-lista.ativo:before {
        opacity: 1
    }

    header .icone-lista.direita:before {
        display: inline-block;
        transition: color .2s ease, transform .2s ease;
    }

    header .icone-lista.direita:hover:before,
    header .icone-lista.direita:focus:before {
        color: var(--mu-primaria-texto, #409fff);
        transform: scale(1.2);
    }

body, nav .ativo a, .t2 td, .links a:hover {
    background: var(--mu-superficie-sutil, #f2f2f2)
}

.login .icone-menu:before {
    content: "h"
}

.conf .icone-menu:before {
    content: "o"
}

.menu, .jm, .flut, .inativo:before {
    position: absolute
}

.menu {
    left: 58px;
    padding: 0 1em 1em;
    z-index: 4
}

.menu, .jm, .login .geral {
    border: solid var(--mu-borda, #c5cacb);
    border-width: 0 1px 1px;
    box-shadow: 0 0 0 6px rgba(0, 0, 0, .05)
}

.login .geral {
    border-width: 1px;
    margin: 10% auto;
    width: 442px;
}

.menu-links a {
    padding: 3px 0
}

.jm {
    border-width: 1px;
    padding: 8px
}

.menu-links dl {
    float: left;
    margin: 1em
}

.usuario {
    background: var(--mu-superficie-sutil, #f6f6f6);
    border-bottom: 1px solid var(--mu-borda-media, #e4e6e8);
    margin: 0 -1em 1em;
    padding: 6px 0 6px 1em
}

.separador, footer, .final {
    border-top: 1px solid var(--mu-borda-media, #e4e6e8);
    box-shadow: 0 6px rgba(0, 0, 0, .025) inset
}

.separador {
    padding-top: 2em
}

.overlay {
    background: rgba(0, 0, 0, .6);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
}

.modal-info {
    left: 4em;
    padding: 2em;
    right: 4em;
    top: 4em;
}

.modal-conf {
    margin: 33px 0 0 68px;
    width: 200px;
}

.usuario .direita {
    margin-left: 1em
}

.usuario a {
    border-left: 1px solid var(--mu-borda-media, #e4e6e8);
    float: left;
    margin: -6px 0;
    padding: 6px 1em;
}

.login2 h1 {
    color: #fff;
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
}

.usuario a:hover, .t2 .ativo td, .lista .passo a:before, .pa .ativo {
    background: #f25713;
    color: #fff
}

.flut {
    right: 1em;
    top: 1em
}

header, nav, footer, .menu-links a, .links a {
    display: block
}

.erro {
    border: 1px solid var(--mu-laranja-borda, #f25713) !important;
    border-color: var(--mu-laranja-borda, #f25713);
    color: var(--mu-laranja-texto, #f25713);
}

.obrigatorio:after {
    color: var(--mu-laranja-texto, #f25713);
    content: "*";
    font-size: 1.4em;
    line-height: 1em;
    margin: 0 0 0 5px;
}

input, textarea, select, button:not(.no-global-button):not(.toast-close-button) {
    -moz-box-sizing: border-box;
    border: 1px solid var(--mu-borda, #c5cacb);
    border-radius: 2px;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, .05) inset;
    box-sizing: border-box;
    font: 1em/16px arial, sans-serif;
    padding: 4px;
}

input:focus, textarea:focus, select:focus, button:focus:not(.no-global-button):not(.toast-close-button) {
    border-color: var(--mu-azul-microuniverso-borda, #43A4D1);
    outline: none;
}

input, textarea, select {
    color: var(--mu-texto, #333333);
}

select {
    height: 26px
}

.direita, header .direita {
    float: right
}

.legenda {
    padding: 0 19px 0
}

select[size] {
    height: auto
}

.none {
    display: none
}

.icone-topo.ativo {
    display: block
}

.icone-topo {
    background: var(--mu-superficie-sutil, #f2f2f2);
    bottom: 0;
    box-shadow: -1px -1px 3px rgba(0, 0, 0, .5);
    padding: .5em;
    position: fixed;
    right: 0
}

[class*="logo-"]:before {
    float: left;
    margin: 0 1em 0 0;
}

.logo-cliente:before, .logo-microuniverso:before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
    border-left: 1px solid var(--mu-borda-sutil, #f2f2f2);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.05) inset;
    content: "";
    height: 58px;
    margin: -13px 0 0;
    width: 168px;
}

.logo-microuniverso:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    width: 220px
}

.rodape:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    display: inline-block;
    height: 38px;
    margin: 0 1em 0 0;
    vertical-align: middle
}

nav a, nav li, fieldset label:first-child, .label:first-child, .f2, .f3, .lateral {
    float: left
}

    nav a:hover {
        background: rgba(0, 0, 0, .12)
    }

nav ul, .lista-dados {
    overflow: hidden
}

.t1, .t2, .t3 {
    width: 100%
}

    .t1 th, .t1 td, .msg {
        border: 1px solid var(--mu-borda, #c5cacb);
        box-shadow: 1px 1px rgba(255, 255, 255, .5) inset;
        padding: 0px 6px 0px 6px;
    }

.msg {
    background: var(--mu-destaque, #ffdf5f);
    border-color: rgba(0, 0, 0, .1);
    padding: 8px;
}

header, fieldset .ob label:first-child, .ob .label:first-child, header .icone-sub, .inativo {
    position: relative
}

.msg a {
    padding: 4px 10px;
    text-decoration: underline;
}

fieldset .ob label:first-child:after, .label:first-child:after {
    color: #f03;
    content: "*";
    font-size: 18px;
    position: absolute;
    right: 0
}

.t1 a:hover {
    color: #f03;
    text-decoration: underline
}

.t1 .selecionado {
    background: rgba(255, 255, 255, .8)
}

    .t1 .selecionado td {
        box-shadow: 0 -1px rgba(255, 223, 95, .5) inset
    }

.t1 {
    border-collapse: collapse
}

.t2, .t3 .t4 {
    border-spacing: 1px
}

.l {
    border: 1px solid var(--mu-borda-media, #e4e6e8);
    padding: 4px 8px
}

.pa {
    margin: 0.5em 0 0
}

.c, .t1 .c {
    text-align: center
}

h1, h2, h3, h4, h5, h6, .ne, .menu dt, .t2 .ativo th, .t3 .destaque {
    font-weight: 700
}

.msg + .msg {
    border-top: 0;
    margin-top: -16px
}

fieldset textarea {
    height: 60px;
    overflow: auto;
    width: 75%
}

fieldset {
    border: 0;
    padding: 0
}

    fieldset div {
        clear: both;
        margin: 0 0 4px;
        min-height: 26px
    }

    fieldset label, .label, .d, .t2 td, .t1 .d, .t3 th {
        text-align: right
    }

    fieldset label, .label {
        font-weight: 400;
        margin: 0;
        padding: 3px 10px 3px 0;
        width: 160px;
    }

.t2 td, .t3 th, .t3 td {
    padding: 6px
}

.t3 th {
    width: 192px
}

.t3 td + td {
    border-left: 1px solid var(--mu-borda-forte, #daddde)
}

.labeldata {
    font-weight: 400;
    margin: 0;
    padding: 3px 10px 3px 0;
    text-align: left;
    width: 160px;
}

.lateral {
    clear: none
}

.lateral, .tam-auto label, [type="file"] {
    width: auto
}

.tam-selecao {
    width: 31px
}

.login .submit {
    margin: 0 0 0 70px
}

.inativo {
    opacity: .5
}

    .inativo:before {
        bottom: 0;
        content: "";
        left: 0;
        right: 0;
        top: 0;
    }

.quebra {
    clear: left
}

.dica-usuario {
    margin-left: 30px;
    font-size: x-small;
}

.tpc {
    background-color: var(--mu-superficie-sutil, #e5e7e7) !important;
}

label.tam-1 {
    width: 70px
}

.tam-1 input, .tam-1 select, .tam-1 textarea {
    width: 60px
}

label.tam-2 {
    width: 110px
}

.tam-2 input, .tam-2 select, .tam-2 textarea {
    width: 100px
}

label.tam-3 {
    width: 210px
}

.tam-3 input, .tam-3 select, .tam-3 textarea {
    width: 200px
}

label.tam-4 {
    width: 290px
}

.tam-4 input, .tam-4 select, .tam-4 textarea {
    width: 280px
}

label.tam-5 {
    width: 370px
}

.tam-5 input, .tam-5 select, .tam-5 textarea {
    width: 360px
}

label.tam-6 {
    width: 350px
}

.tam-6 input, .tam-6 select, .tam-6 textarea {
    width: 440px
}

.tam-max input, .tam-max select, .tam-max textarea {
    width: calc(100% - 10px)
}

.label-auto label {
    display: block;
    float: none;
    text-align: left;
    width: auto;
}

.label-radio {
    display: inline-block;
    float: none;
    text-align: left;
    width: auto;
    cursor: pointer;
    /*vertical-align: central;*/
}

.label-checkbox-dropdown {
    display: inline-block;
    float: none;
    text-align: right;
    width: auto;
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    padding: 0px 10px 0px 10px;
}

.checkbox-dropdown {
    display: inline-block;
    float: none;
    text-align: right;
    width: auto;
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    padding: 0px 10px 0px 10px;
}

[type="checkbox"], [type="radio"] {
    border: 0;
    height: 15px;
    vertical-align: central;
    cursor: pointer;
    width: 15px !important
}

/* checkbox/radio nativos (appearance:auto) ignoram border e outline no proprio widget —
   confirmado com screenshot pixel a pixel, nao so getComputedStyle. box-shadow eh a unica
   forma que realmente pinta um anel visivel ao redor deles nesse caso (ver Aprendizado_CSS.md). */
[type="checkbox"]:hover, [type="radio"]:hover,
[type="checkbox"]:focus, [type="radio"]:focus {
    box-shadow: 0 0 0 2px var(--mu-azul-microuniverso-borda, #43A4D1);
    outline: none;
}

h3, h5, .menu dt {
    font-size: 1.077em;
    line-height: 1.917
}

h1 {
    box-shadow: 0 0 2px rgba(0, 0, 0, .1);
    font-size: 1.385em;
    line-height: 32px;
    margin: 0;
    padding: 13px;
    white-space: nowrap;
}

h2:not(.no-global-h2) {
    border-bottom: 1px solid rgba(0, 0, 0, .05);
    font-size: 1.308em;
    line-height: 1.9;
}

.pa a {
    display: inline-block;
    padding: 2px 9px
}

.de {
    padding-left: 30px
}

button:not(.no-global-button):not(.toast-close-button) {
    background: var(--mu-primaria, #409fff);
    border-color: rgba(0, 0, 0, .3);
    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .12) inset;
    padding-left: 10px;
    padding-right: 10px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .3);
    /* width: auto !important; */
}

/* Foco dos botoes azuis: o anel de foco padrao do navegador e azul e some
   dentro do botao, que tambem e azul. Aqui o foco vira dois sinais somados:
   o fundo escurece para um azul mais fechado E ganha um anel BRANCO por fora,
   com um halo escuro para separar do que estiver atras.
   Usa \`:focus\` (nao \`:focus-visible\`) de proposito: o fluxo do sistema navega
   por Enter/Tab mas tambem chega ao botao por clique, e o \`:focus-visible\`
   nao dispara no clique de mouse. */
button:not(.no-global-button):not(.toast-close-button):focus:not(:disabled) {
    background: var(--mu-primaria-foco, #1c78d6);
    border-color: var(--mu-primaria-foco, #1c78d6);
    outline: none;
    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .12) inset,
                0 0 0 2px var(--mu-anel-foco-sobre-azul, #fff),
                0 0 0 3px var(--mu-anel-foco-contorno, rgba(0, 0, 0, 0.45));
}

button:not(.no-global-button):not(.toast-close-button), .t2 td, .lista a, .pa .ativo, .links a {
    border-radius: 2px
}

.ordenar.as:after, .ordenar.ds:after {
    border: solid;
    border-color: #80888a transparent;
    border-width: 6px 6px 0;
    content: "";
    float: right;
    margin: 7px 0 0 6px
}

.ordenar.as:after {
    border-width: 0 6px 6px
}

.ordenar, .clicavel {
    cursor: pointer
}

    .ordenar:hover {
        box-shadow: 1px 1px 6px rgba(0, 0, 0, .1) inset;
    }

.rodape:hover:before {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, .1)
}

legend {
    border: 0;
    color: var(--mu-texto, #333739);
    display: inline;
    font-size: 1em;
    margin: 0;
    padding: 0 2px
}

.apresentacao {
    margin: 3em
}

.secao {
    border-left: 1px solid var(--mu-borda-media, #e4e6e8);
    display: inline-block;
    margin: -13px 0 -13px 1em;
    padding: 13px 26px;
}

.logo-cliente .secao {
    margin: -13px 0
}

.login .legenda {
    font-size: 12px;
    line-height: 1em
}

.secao:before, [class^="splash-"]:before {
    border: solid;
    border-color: var(--mu-borda-sutil, #f2f2f2) transparent;
    border-width: 40px 13px 0 0;
    content: "";
    margin: -13px 0 0 -26px;
    position: absolute;
}

.sub2:after {
    border: solid;
    border-color: var(--mu-borda-forte, #daddde) transparent;
    border-width: 6px 6px 0;
    content: "";
    display: inline-block;
    margin: 0 0 0 6px;
    vertical-align: middle
}

header .icone-sub {
    margin: 0 19px 0 13px;
    padding: 0 30px 0 13px
}

a:hover, a:focus {
    text-decoration: none
}

legend .icone-sub {
    margin: 0 0 0 9px;
    vertical-align: sub
}

legend .oculto:before {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.rotate:before {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.submit button:not(.no-global-button):not(.toast-close-button), .submit a {
    display: inline-block;
    margin: 0 3px 0 0;
    padding: 7px 1em;
}

.submit a {
    padding: 6px 1em
}

[disabled]:not(.no-global-input) {
    background: var(--mu-superficie-sutil, #f1f2f2);
    border-color: var(--mu-borda, #c5cacb) var(--mu-borda-forte, #daddde) var(--mu-borda-forte, #daddde) var(--mu-borda, #c5cacb);
    color: var(--mu-texto, #333739);
}

button:not(.no-global-button):not(.toast-close-button)[disabled] {
    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .05) inset;
    text-shadow: none;
    background: var(--mu-superficie-sutil, #f1f2f2);
    color: var(--mu-texto, #333739);
}

nav a {
    color: #e4e6e8;
    margin: 0 1em;
    padding: 10px 1em
}

footer {
    clear: both;
    padding: 1em 2em;
}

footer, .menu-links, .legenda, .links a {
    font-size: .923em
}

a {
    text-decoration: none
}

.migalha {
    margin: 0 5px 0 0
}

    .migalha:after {
        content: "g";
        display: inline-block;
        margin: 0 0 0 9px;
        vertical-align: text-bottom
    }

footer, .legenda {
    color: var(--mu-texto-desab, #bbb)
}

.ma {
    padding: 10px
}

.lateral {
    margin-right: 10px
}

[readonly] {
    border-color: var(--mu-borda-media, #e4e6e8)
}

ul {
    margin: 0;
    padding: 0 0 0 15px;
}

nav ul, nav li, .lista ul, .lista ul, .links, .final {
    box-shadow: none;
    list-style: none;
    padding: 0
}

a.ativo {
    color: var(--mu-texto, #000)
}

h5, h5 a {
    color: #235987
}

.final {
    background: linear-gradient(rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));
    margin: 2em -2em -2em;
    padding: 2em
}

h3, .menu dt, a:hover, .migalha a:hover, .az, .icone-sub:hover:before, .icone-sugerido:hover:before, a.icone-info:hover:before, a.icone-email:hover:before, a.icone-imprimir:hover:before, a.icone-lista:hover:not(.direita):before, a.icone-topo:hover:before, fieldset [class*="icone-"]:hover:before {
    color: var(--mu-primaria-texto, #409fff)
}

.pa, .tc, .migalha a, .usuario a, header .icone-sub, .secao, .migalha {
    color: var(--mu-texto-suave, #80888a)
}

legend {
    color: #5e8eb7
}

.secao, .t2 th, .t3 th, .login .legenda {
    font-weight: 400
}

h5 a:hover, .ve {
    color: #f03
}

nav a:hover, button:not(.no-global-button):not(.toast-close-button) {
    color: #fff
}

.t1 th {
    background: var(--mu-superficie-forte, #daddde)
}

th {
    padding: 1px;
    text-align: left;
}

select, .menu, header, .t1 tr:hover, .jm, .t3 .destaque, .icone-menu, .contrai:hover {
    background: var(--mu-superficie, #fff)
}

.t3 .destaque {
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05)
}

nav li {
    background-image: none
}

button:active:not([disabled]) {
    background: var(--mu-azul-fundo, #3c8ac9)
}

.margem {
    margin: 2em;
}

th.as:after, .ds:after {
    border: solid;
    border-color: rgba(255, 255, 255, .6) transparent;
    border-width: 4px 4px 0;
    float: right;
    margin: 6px 0 0 6px
}

th.as:after {
    border-width: 0 4px 4px
}

.lista a, .links a {
    border: 1px solid transparent;
    display: block;
    margin: 0 0 3px;
    padding: 5px 1em;
}

.links a {
    margin: 0;
    padding: 4px 10px;
}

img {
    background: none;
    border: 0
}

input::-moz-focus-inner {
    border: 0;
    padding: 0
}

button:not(.no-global-button):not(.toast-close-button)[class*="icone-"] {
    background: none;
    border-color: transparent;
    box-shadow: none;
    color: var(--mu-texto-suave, #80888a);
    text-shadow: 0 1px 1px var(--mu-sombra-texto, #fff);
}

    button:not(.no-global-button):not(.toast-close-button)[class*="icone-"]:before {
        margin: -2px 8px -2px 0
    }

.margem-filtro {
    margin: 1em 0 0 0
}

button:not(.no-global-button):not(.toast-close-button)[class*="icone-"]:hover:not([disabled]), .links a:hover {
    background: var(--mu-superficie, #fff);
    border-color: var(--mu-borda-media, #e4e6e8);
    cursor: pointer
}

button:not(.no-global-button):not(.toast-close-button)[class*="icone-"]:active:not([disabled]), .icone-menu.ativo, .login, .t3 th {
    background: var(--mu-superficie-media, #e4e6e8)
}

button:not(.no-global-button):not(.toast-close-button)[class*="icone-"]:active:not([disabled]), .icone-menu.ativo, .login, .t3 th {
    background: var(--mu-superficie-media, #e4e6e8)
}

button:not(.no-global-button):not(.toast-close-button)[class*="icone-"][disabled] {
    color: var(--mu-texto-desab, #bbb)
}

    button:not(.no-global-button):not(.toast-close-button)[class*="icone-"][disabled]:before {
        color: #daddde
    }

button:not(.no-global-button):not(.toast-close-button).ativo:hover:not([disabled]), button:not(.no-global-button).ativo, li.ativo a {
    background: var(--mu-superficie-media, #e4e6e8);
    border-color: var(--mu-borda-forte, #daddde);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, .05) inset;
    color: var(--mu-texto, #000)
}

fieldset [class*="icone-"]:before {
    margin: 3px 8px 3px 3px
}

fieldset [class*="icone-"]:empty:before {
    margin: 3px
}

nav a:after, nav a:before {
    border: solid;
    border-color: transparent;
    border-width: 40px 13px 0 0;
    content: "";
    float: left;
    margin: -10px -26px
}

nav a:after {
    border-width: 40px 0 0 13px;
    float: right
}

nav a:hover:after, nav a:hover:before {
    border-color: transparent rgba(0, 0, 0, .12)
}

nav .ativo a:after, nav .ativo a:before {
    border-color: transparent var(--mu-borda-sutil, #f2f2f2)
}

nav .ativo a {
    background: var(--mu-superficie-sutil, #f2f2f2);
    color: var(--mu-texto, #000);
    text-shadow: 0 1px 1px var(--mu-sombra-texto, #fff)
}

nav {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .2)) #80888a;
    padding: 5px 13px 0;
}

.arvore ul {
    list-style: none;
    padding: 0
}

.arvore li {
    margin: 4px 0;
}

    .arvore li li {
        margin: 4px 0 4px 1.5em;
    }

.contrai {
    border: 1px solid rgba(0, 0, 0, .05);
    float: left;
    margin: 0 .5em 0 0;
    padding: 4px 6px
}

    .contrai:before {
        border: solid;
        border-color: transparent #80888a;
        border-width: 4px 0 4px 4px;
        content: "";
        float: left;
    }

.expandido > .contrai {
    padding: 6px 4px
}

    .expandido > .contrai:before {
        border-color: #80888a transparent;
        border-width: 4px 4px 0
    }

.limpo:before {
    border-color: transparent
}

/* .mapa, .grafico {
    background: url(images/mapa.png);
    border: 1px solid #c5cacb;
    height: 320px;
    margin: 0 0 2em
} */

/* .grafico {
    background: url(images/grafico.png) center 0 no-repeat #fff
} */

.lista, .principal, aside {
    display: table-cell;
    vertical-align: top
}

.lista {
    border-right: 1px solid var(--mu-borda-media, #e4e6e8);
    box-shadow: 1px 0 var(--mu-sombra-texto, #fff);
    padding: 2em 1em;
    width: 227px;
}

aside {
    width: 245px;
    padding: 0px 0px 0px 2em;
}

.aside {
    padding: 0.5em;
    background: var(--mu-superficie-forte, #daddde);
    box-shadow: 2px 0 6px -2px rgba(0, 0, 0, .2) inset, -1px 0 var(--mu-sombra-texto, #fff);
    min-height: 100%;
}

.principal {
    padding: 2em;
}

.lista-dados dl {
    float: left;
    padding: 1em;
    width: 240px
}

.lista-dados dt {
    float: left;
    font-weight: 700;
    margin: 0 .5em 0 0
}

    .lista-dados dt:after {
        content: ":"
    }

[class*="leg-cor-"] {
    margin: 0 1em 0 0
}

    [class*="leg-cor-"]:before {
        border-radius: 3px;
        content: "";
        display: inline-block;
        height: 16px;
        margin: 0 .5em 0 0;
        vertical-align: sub;
        width: 16px;
    }

.t1 [class*="cor-"] td:first-child {
    padding-left: 10px
}

.t1 [class*="cor-"]:not(.cor-0) td {
    background: rgba(255, 255, 255, .5)
}

.cor-0 td:first-child {
    box-shadow: 4px 0 #e4e6e8 inset
}

.leg-cor-1:before {
    background: var(--mu-superficie-escura, #BEBEBE)
}

.cor-1 td:first-child {
    box-shadow: 4px 0 #BEBEBE inset
}

.leg-cor-2:before {
    background: #f00
}

.cor-2 td:first-child {
    box-shadow: 4px 0 #f00 inset
}

.leg-cor-3:before {
    background: var(--mu-destaque, #fc0)
}

.cor-3 td:first-child {
    box-shadow: 4px 0 #fc0 inset
}

.leg-cor-4:before {
    background: #0a0
}

.cor-4 td:first-child {
    box-shadow: 4px 0 #0a0 inset
}

.leg-cor-5:before {
    background: #11aa99
}

.cor-5 td:first-child {
    box-shadow: 4px 0 #11aa99 inset
}

.leg-cor-6:before {
    background: #556b2f
}

.cor-6 td:first-child {
    box-shadow: 4px 0 #556b2f inset
}

.leg-cor-7:before {
    background: coral
}

.cor-7 td:first-child {
    box-shadow: 4px 0 coral inset
}

.leg-cor-8:before {
    background: darkgoldenrod
}

.cor-8 td:first-child {
    box-shadow: 4px 0 darkgoldenrod inset
}

.leg-cor-produto-em-oferta:before {
    background: #0000FF
}

.cor-produto-em-oferta td:first-child {
    box-shadow: 4px 0 #0000FF inset
}

.leg-cor-sob-encomenda:before {
    background: #EC780F
}

.leg-cor-documento-quitado-lucros-e-perdas:before { /*FNX-4896*/
    background: #00C800
}

.cor-sob-encomenda td:first-child {
    box-shadow: 4px 0 #EC780F inset
}

.leg-cor-fora-linha:before {
    background: #00C800
}

.cor-fora-linha td:first-child {
    box-shadow: 4px 0 #00C800 inset
}

.leg-cor-fora-mix:before {
    background: #800000
}

.cor-fora-mix td:first-child {
    box-shadow: 4px 0 #800000 inset
}

.leg-cor-estoque-indisponivel:before {
    background: #FF0000
}

.cor-estoque-indisponivel td:first-child {
    box-shadow: 4px 0 #FF0000 inset
}

.leg-cor-entrega-invalida:before {
    background: #FF0080
}

.cor-entrega-invalida td:first-child {
    box-shadow: 4px 0 #FF0080 inset
}

.leg-cor-possui-agregado:before {
    background: #808000
}

.cor-possui-agregado td:first-child {
    box-shadow: 4px 0 #808000 inset
}

.leg-cor-agregado-promocao:before {
    background: #400080
}

.cor-agregado-promocao td:first-child {
    box-shadow: 4px 0 #400080 inset
}


.leg-cor-produto-importado:before { /* FNX-5558*/
    background: var(--mu-azul-fundo, #3c8ac9)
}

.cor-produto-importado td:first-child { /* FNX-5558*/
    box-shadow: 4px 0 #3c8ac9 inset
}


.leg-cor-retirada-centro-distribuicao:before {
    background: #FF8080
}

.cor-retirada-centro-distribuicao td:first-child {
    box-shadow: 4px 0 #FF8080 inset
}

.leg-cor-produto-nao-aceita-devolucao:before {
    background: var(--mu-destaque, #FFFF00)
}

.cor-produto-nao-aceita-devolucao td:first-child {
    box-shadow: 4px 0 #FFFF00 inset
}

.leg-cor-cotacao-perdida:before {
    background: #808080
}

.cor-cotacao-perdida td:first-child {
    box-shadow: 4px 0 #808080 inset
}

.leg-cor-oferta-agregado:before {
    background: #8000FF
}

.cor-oferta-agregado td:first-child {
    box-shadow: 4px 0 #8000FF inset
}

.leg-cor-todos-enderecos:before {
    background: var(--mu-superficie-escura, #C0C0C0)
}

.cor-todos-enderecos td:first-child {
    box-shadow: 4px 0 #C0C0C0 inset
}

.leg-cor-faturamento-entrega-enderecos:before {
    background: #FF8000
}

.cor-faturamento-entrega-enderecos td:first-child {
    box-shadow: 4px 0 #FF8000 inset
}

.leg-cor-cobranca-entrega-enderecos:before {
    background: #000000
}

.cor-cobranca-entrega-enderecos td:first-child {
    box-shadow: 4px 0 #000000 inset
}

.leg-cor-faturamento-cobranca-enderecos:before {
    background: #800000
}

.cor-faturamento-cobranca-enderecos td:first-child {
    box-shadow: 4px 0 #800000 inset
}

.leg-cor-entrega-enderecos:before {
    background: #FF0000
}

.cor-entrega-enderecos td:first-child {
    box-shadow: 4px 0 #FF0000 inset
}

.leg-cor-cobranca-enderecos:before {
    background: #0000FF
}

.cor-cobranca-enderecos td:first-child {
    box-shadow: 4px 0 #0000FF inset
}

.leg-cor-faturamento-enderecos:before {
    background: #00FF00
}

.cor-faturamento-enderecos td:first-child {
    box-shadow: 4px 0 #00FF00 inset
}

.cor-cancelamento-nao-pode-ser-cancelado td:first-child {
    box-shadow: 4px 0 #800000 inset
}
/*FNX-970*/

.leg-cor-cancelamento-nao-pode-ser-cancelado:before {
    background: #FF0000
}
/*FNX-970*/

/*manut-301*/
.leg-cor-DisponibilidadeCarga-DataDisponivel:before {
    background: blue
}

.cor-DisponibilidadeCarga-DataDisponivel td:first-child {
    box-shadow: 4px 0 blue inset
}

.leg-cor-DisponibilidadeCarga-SemCadastro:before {
    background: green
}

.cor-DisponibilidadeCarga-SemCadastro td:first-child {
    box-shadow: 4px 0 green inset
}

.leg-cor-DisponibilidadeCarga-DataIndisponivel:before {
    background: red
}

.cor-DisponibilidadeCarga-DataIndisponivel td:first-child {
    box-shadow: 4px 0 red inset
}


.splash {
    border-spacing: 10px;
    display: table;
    width: 100%;
}

.linha {
    display: table-row
}

.splash dl {
    background: var(--mu-superficie, #fff);
    border-radius: 4px;
    box-shadow: 1px 2px 6px rgba(0, 0, 0, .05) inset;
    display: table-cell;
    width: 25%
}

.splash a {
    border-top: 1px solid var(--mu-borda-media, #e4e6e8);
    box-shadow: 0 6px 6px -4px rgba(0, 0, 0, .05) inset;
    display: block;
    padding: 12px
}

[class^="splash-"] {
    border: 1px solid var(--mu-borda-media, #e4e6e8);
    border-top: 3px solid var(--mu-laranja-borda, #f25713)
}

    [class^="splash-"]:before {
        border-color: rgba(0, 0, 0, .02) transparent;
        margin: 0;
    }

    [class^="splash-"] dt {
        /* background: url(../img/splash.svg) center 30px no-repeat; */
        color: var(--mu-texto-suave, #80888a);
        font-size: 1.385em;
        padding: 120px 0 20px;
        text-align: center;
    }

.splash-vendas dt {
    background-position: center -170px
}

.splash-vendas {
    border-top-color: #5ac93c
}

.splash-financeiro dt {
    background-position: center -370px
}

.splash-financeiro {
    border-top-color: #fcb404
}

.splash-ti dt {
    background-position: center -570px
}

.splash-ti {
    border-top-color: var(--mu-primaria-borda, #409fff)
}

.splash-compras [class^="icone-"]:before {
    color: var(--mu-laranja-texto, #f25713)
}

.splash-vendas [class^="icone-"]:before {
    color: #5ac93c
}

.splash-financeiro [class^="icone-"]:before {
    color: #fcb404
}

.splash-ti [class^="icone-"]:before {
    color: var(--mu-primaria-texto, #409fff)
}

.splash [class^="icone-"]:hover:before, .splash [class^="icone-"]:hover {
    color: var(--mu-texto, #333739) !important
}


/* temas */

.wiz ul {
    counter-reset: item
}

.wiz li a:before {
    border-radius: 2px;
    color: var(--mu-texto-desab, #bbb);
    content: counter(item);
    counter-increment: item;
    float: left;
    line-height: 24px;
    margin: -2px 6px -2px -10px;
    text-align: center;
    width: 24px;
}

.fieldset-box {
    border: 1px solid;
    border-color: lightgrey;
    width: 40%;
    padding: 2px 0 5px 0px;
}

    .fieldset-box > legend {
        color: var(--mu-texto, black);
        border: none;
        width: 130px;
        text-align: center;
    }

@media screen and (max-width: 1200px) {
    .lista {
        background: var(--mu-superficie-sutil, #f2f2f2);
        border: 0;
        border-bottom: 1px solid var(--mu-borda-media, #e4e6e8);
        box-shadow: 0 1px rgba(255, 255, 255, .5);
        display: table-caption;
        overflow: hidden;
        padding: 1em;
        width: auto;
    }

        .lista a {
            margin: 0 .5em 0 0
        }

        .lista li, .lista a {
            float: left
        }
}

@media screen and (max-width: 900px) {
    .lateral {
        float: none;
        margin-right: 0
    }

    label.tam-1, label.tam-2, label.tam-3, label.tam-4, label.tam-5 {
        width: 150px
    }
}

@media screen and (max-width: 900px) and (min-width: 700px) {
    .splash [class*="icone-"]:before {
        display: block;
        margin: 0 0 8px;
        width: 20px
    }

    .fieldset-box {
        border: 1px solid;
        border-color: lightgrey;
        width: 100%;
        padding: 2px 0 5px 5px;
    }

        .fieldset-box > legend {
            color: var(--mu-texto, black);
            border: none;
            margin-left: 0%;
        }
}

@media screen and (max-width: 700px) {
    fieldset label, fieldset label:first-child, label.tam-1, label.tam-2, label.tam-3, label.tam-4, label.tam-5, .lista-dados dl {
        display: block;
        float: none;
        text-align: left;
        width: auto;
    }

    .legenda {
        display: none
    }

    .splash, .linha, .splash dl {
        display: block
    }

        .splash dl {
            margin: 10px 10px 20px;
            width: auto;
        }
}

@media screen and (max-width: 500px) {
    fieldset label:first-child {
        display: block;
        float: none;
        text-align: left;
        width: auto
    }

    input, select, textarea {
        width: calc(100% - 13px) !important
    }

    .responsiv {
        overflow: auto
    }

    .principal, aside {
        display: block;
    }

    [class*="logo-"]:before {
        display: none
    }

    nav, .lista {
        padding: 4px
    }

        nav a, .lista a {
            margin: 1px
        }

            nav a:after, nav a:before, nav li:after, nav li:before {
                content: none
            }

        nav a {
            border-radius: 2px;
            padding: 8px 12px;
        }
}

@media print {
    nav ul, .submit, footer, .no-im {
        display: none
    }

    .corpo {
        padding: 10px 0 0
    }

    h1 {
        padding: 0 0 10px
    }

    h1, h2 {
        color: var(--mu-texto, #000)
    }

    header {
        border-bottom: 1px solid;
        margin: 0 0 10px
    }

    header, .t1 th {
        border-color: var(--mu-borda, #c5cacb)
    }

    h1:before {
        border: 0;
        content: "PMMG - ";
        display: inline;
        margin: 0;
        padding: 0;
        vertical-align: inherit
    }
}


.ambiente-menu {
    align-self: stretch;
    background: var(--mu-superficie, rgb(255, 255, 255)) none repeat scroll 0% 0%/auto padding-box border-box;
    border: 1px solid rgb(197, 198, 200);
    border-spacing: 1px 1px;
    box-sizing: border-box;
    color: var(--mu-texto, rgb(51, 51, 51));
    cursor: pointer;
    font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
    list-style: none outside none;
    margin: 0px;
    outline: rgb(51, 51, 51) none 0px;
    padding: 1px;
    perspective-origin: 96px 212px;
    position: absolute;
    text-align: left;
    transform-origin: 96px 212px;
    width: 200px;
    z-index: 150;
}

    .ambiente-menu:before {
        align-self: stretch;
        border-bottom: 10px solid rgb(197, 198, 200);
        border-left: 10px solid rgba(0, 0, 0, 0);
        border-right: 10px solid rgba(0, 0, 0, 0);
        border-spacing: 1px 1px;
        border-top: 0px solid rgba(0, 0, 0, 0);
        box-sizing: border-box;
        color: var(--mu-texto, rgb(51, 51, 51));
        content: ' ';
        cursor: pointer;
        display: block;
        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
        height: 10px;
        list-style: none outside none;
        outline: rgb(51, 51, 51) none 0px;
        perspective-origin: 10px 5px;
        position: absolute;
        right: 5px;
        text-align: left;
        top: -10px;
        transform-origin: 10px 5px;
        width: 20px;
    }

    .ambiente-menu:after {
        align-self: stretch;
        border-bottom: 9px solid rgb(255, 255, 255);
        border-left: 9px solid rgba(0, 0, 0, 0);
        border-right: 9px solid rgba(0, 0, 0, 0);
        border-spacing: 1px 1px;
        border-top: 0px solid rgba(0, 0, 0, 0);
        box-sizing: border-box;
        color: var(--mu-texto, rgb(51, 51, 51));
        content: ' ';
        cursor: pointer;
        display: block;
        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
        height: 9px;
        list-style: none outside none;
        outline: rgb(51, 51, 51) none 0px;
        perspective-origin: 9px 4.5px;
        position: absolute;
        right: 6px;
        text-align: left;
        top: -9px;
        transform-origin: 9px 4.5px;
        width: 18px;
    }

    .ambiente-menu .menu-item {
        border: 0px none rgb(51, 51, 51);
        border-spacing: 1px 1px;
        box-sizing: border-box;
        color: var(--mu-texto, rgb(51, 51, 51));
        cursor: pointer;
        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
        height: 36px;
        list-style: none outside none;
        outline: rgb(51, 51, 51) none 0px;
        perspective-origin: 94px 18px;
        transform-origin: 94px 18px;
        width: 196px;
    }

        .ambiente-menu .menu-item a.link {
            border: 0px none rgb(51, 51, 51);
            border-spacing: 1px 1px;
            box-sizing: border-box;
            color: var(--mu-texto, rgb(51, 51, 51));
            display: block;
            font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
            height: 36px;
            list-style: none outside none;
            outline: rgb(51, 51, 51) none 0px;
            padding: 2px 5px;
            perspective-origin: 94px 18px;
            position: relative;
            text-align: left;
            text-decoration: none;
            transform-origin: 94px 18px;
            width: 196px;
        }

            .ambiente-menu .menu-item a.link:hover {
                -moz-border-radius: 2px;
                -webkit-border-radius: 2px;
                background: var(--mu-superficie-sutil, #f2f3f2);
                border-color: #f2f3f2;
                border-radius: 2px;
                color: white;
            }

            .ambiente-menu .menu-item a.link .dot {
                background: rgb(253, 171, 61) none repeat scroll 0% 0%/auto padding-box border-box;
                border: 1px solid rgb(197, 198, 200);
                border-radius: 100% 100% 100% 100%;
                border-spacing: 1px 1px;
                box-sizing: border-box;
                color: var(--mu-texto, rgb(51, 51, 51));
                display: inline-block;
                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
                height: 16px;
                list-style: none outside none;
                margin: 8px 0px 3px;
                outline: rgb(51, 51, 51) none 0px;
                perspective-origin: 8px 8px;
                text-align: left;
                transform-origin: 8px 8px;
                width: 16px;
            }

            .ambiente-menu .menu-item a.link .label {
                border: 0px none rgb(253, 171, 61);
                border-radius: 3.5px 3.5px 3.5px 3.5px;
                border-spacing: 1px 1px;
                box-sizing: border-box;
                display: inline-block;
                font: normal normal normal normal 14px/25px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
                height: 31.984375px;
                list-style: none outside none;
                margin: 1px 0px 0px;
                max-width: 170px;
                outline: rgb(253, 171, 61) none 0px;
                overflow: hidden;
                overflow-wrap: break-word;
                padding: 2.79999995231628px 8.39999961853027px 4.19999980926514px;
                perspective-origin: 55.890625px 15.984375px;
                text-align: center;
                text-overflow: ellipsis;
                transform-origin: 55.890625px 15.984375px;
                vertical-align: top;
                white-space: nowrap;
                width: 100%;
                word-wrap: break-word;
            }

        .ambiente-menu .menu-item .edit {
            color: rgb(82, 151, 239);
            float: right;
            font-size: 14px;
            height: 31.984375px;
            margin: 1px 0px 0px;
            padding: 2.79999995231628px 4px 4.19999980926514px;
        }

        .ambiente-menu .menu-item .delete {
            color: rgb(82, 151, 239);
            float: right;
            font-size: 14px;
            height: 31.984375px;
            margin: 1px 0px 0px;
            padding: 2.79999995231628px 2px 4.19999980926514px 8px;
        }

        .ambiente-menu .menu-item a.link .separator {
            align-self: stretch;
            background: var(--mu-superficie-sutil, rgb(224, 229, 225)) none repeat scroll 0% 0%/auto padding-box border-box;
            border: 0px none rgb(51, 51, 51);
            border-spacing: 1px 1px;
            bottom: -1px;
            box-sizing: border-box;
            color: var(--mu-texto, rgb(51, 51, 51));
            font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
            height: 1px;
            list-style: none outside none;
            outline: rgb(51, 51, 51) none 0px;
            perspective-origin: 88.359375px 0.5px;
            position: absolute;
            text-align: left;
            transform-origin: 88.359375px 0.5px;
            width: 184px;
        }


        .ambiente-menu .menu-item .color-label {
            display: block;
        }

            .ambiente-menu .menu-item .color-label .dot {
                background: rgb(253, 171, 61) none repeat scroll 0% 0%/auto padding-box border-box;
                border: 1px solid rgb(197, 198, 200);
                border-radius: 100% 100% 100% 100%;
                border-spacing: 1px 1px;
                box-sizing: border-box;
                color: var(--mu-texto, rgb(51, 51, 51));
                display: inline-block;
                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
                height: 16px;
                list-style: none outside none;
                margin: 8px 0px 3px;
                outline: rgb(51, 51, 51) none 0px;
                perspective-origin: 8px 8px;
                text-align: left;
                transform-origin: 8px 8px;
                width: 16px;
            }

            .ambiente-menu .menu-item .color-label .separator {
                align-self: stretch;
                background: var(--mu-superficie-sutil, rgb(224, 229, 225)) none repeat scroll 0% 0%/auto padding-box border-box;
                border: 0px none rgb(51, 51, 51);
                border-spacing: 1px 1px;
                bottom: -1px;
                box-sizing: border-box;
                color: var(--mu-texto, rgb(51, 51, 51));
                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;
                height: 1px;
                list-style: none outside none;
                outline: rgb(51, 51, 51) none 0px;
                perspective-origin: 88.359375px 0.5px;
                position: absolute;
                text-align: left;
                transform-origin: 88.359375px 0.5px;
                width: 176.71875px;
            }

            .ambiente-menu .menu-item .color-label .input {
                border: none;
                border: 1px solid var(--mu-borda-media, #ddd);
                border-radius: 3px;
                display: inline-block;
                font-size: 14px;
                font-weight: normal;
                margin-left: 5px;
                margin-top: 7px;
                outline: none;
                padding: 3px 3px 3px 10px;
                vertical-align: top;
                width: 128px;
            }

    .ambiente-menu .menu-item-acoes {
        background: var(--mu-superficie-sutil, rgb(246, 248, 250)) none repeat scroll 0% 0%/auto padding-box border-box;
        border: 0px none rgb(51, 51, 51);
        border-spacing: 1px 1px;
        box-sizing: border-box;
        color: var(--mu-texto, rgb(51, 51, 51));
        cursor: pointer;
        font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;
        height: auto;
        outline: rgb(51, 51, 51) none 0px;
        perspective-origin: 50% 50%;
        text-align: right;
        transform-origin: 50% 50%;
        width: auto;
    }

        .ambiente-menu .menu-item-acoes .link {
            border: 0px none rgb(82, 151, 239);
            border-radius: 3px 3px 3px 3px;
            border-spacing: 1px 1px;
            box-sizing: border-box;
            color: rgb(82, 151, 239);
            font: normal normal 300 normal 12px/25px helvetica, arial, sans-serif;
            outline: rgb(82, 151, 239) none 0px;
            padding: 2px 5px;
            perspective-origin: 50% 50%;
            text-align: right;
            text-decoration: none;
            transform-origin: 50% 50%;
        }

.ambiente-col {
    border: 0px none rgb(51, 51, 51);
    border-spacing: 1px 1px;
    color: var(--mu-texto, rgb(51, 51, 51));
    cursor: pointer;
    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;
    outline: rgb(51, 51, 51) none 0px;
    perspective-origin: 71.5px 18px;
    position: relative;
    transform-origin: 71.5px 18px;
}

    .ambiente-col .color {
        border-left: 0px none rgb(255, 255, 255);
        border-right: 0px none rgb(255, 255, 255);
        border-spacing: 1px 1px;
        border-top: 0px none rgb(255, 255, 255);
        color: rgb(255, 255, 255);
        cursor: pointer;
        display: block;
        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
        outline: rgb(255, 255, 255) none 0px;
        overflow: hidden;
        perspective-origin: 71.5px 18px;
        text-align: center;
        text-overflow: ellipsis;
        transform-origin: 71.5px 18px;
        white-space: nowrap;
    }

        .ambiente-col .color span.text {
            border: 0px none rgb(255, 255, 255);
            border-spacing: 1px 1px;
            box-sizing: border-box;
            color: rgb(255, 255, 255);
            cursor: pointer;
            font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
            outline: rgb(255, 255, 255) none 0px;
            text-align: center;
            white-space: nowrap;
        }

.ambientes-separados {
    color: var(--mu-texto, #000000);
    list-style: none;
}

.inconsistencias {
    color: var(--mu-texto, #000000);
    list-style: none;
}

.centro-custo-col {
    border: 0px none rgb(51, 51, 51);
    border-spacing: 1px 1px;
    color: var(--mu-texto, rgb(51, 51, 51));
    cursor: pointer;
    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;
    outline: rgb(51, 51, 51) none 0px;
    perspective-origin: 71.5px 18px;
    position: relative;
    transform-origin: 71.5px 18px;
}

.filial-item-col .color {
    border-left: 0px none rgb(255, 255, 255);
    border-right: 0px none rgb(255, 255, 255);
    border-spacing: 1px 1px;
    border-top: 0px none rgb(255, 255, 255);
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
    outline: rgb(255, 255, 255) none 0px;
    overflow: hidden;
    perspective-origin: 71.5px 18px;
    text-align: center;
    text-overflow: ellipsis;
    transform-origin: 71.5px 18px;
    white-space: nowrap;
}

    .filial-item-col .color span.text {
        border: 0px none rgb(255, 255, 255);
        border-spacing: 1px 1px;
        box-sizing: border-box;
        color: rgb(255, 255, 255);
        cursor: pointer;
        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
        outline: rgb(255, 255, 255) none 0px;
        text-align: center;
        white-space: nowrap;
    }

.centro-custo-col {
    border: 0px none rgb(51, 51, 51);
    border-spacing: 1px 1px;
    color: var(--mu-texto, rgb(51, 51, 51));
    cursor: pointer;
    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;
    outline: rgb(51, 51, 51) none 0px;
    perspective-origin: 71.5px 18px;
    position: relative;
    transform-origin: 71.5px 18px;
}

    .centro-custo-col .color {
        border-left: 0px none rgb(255, 255, 255);
        border-right: 0px none rgb(255, 255, 255);
        border-spacing: 1px 1px;
        border-top: 0px none rgb(255, 255, 255);
        color: rgb(255, 255, 255);
        cursor: pointer;
        display: block;
        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
        outline: rgb(255, 255, 255) none 0px;
        overflow: hidden;
        perspective-origin: 71.5px 18px;
        text-align: center;
        text-overflow: ellipsis;
        transform-origin: 71.5px 18px;
        white-space: nowrap;
    }

        .centro-custo-col .color span.text {
            border: 0px none rgb(255, 255, 255);
            border-spacing: 1px 1px;
            box-sizing: border-box;
            color: rgb(255, 255, 255);
            cursor: pointer;
            font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;
            outline: rgb(255, 255, 255) none 0px;
            text-align: center;
            white-space: nowrap;
        }

.dropdown-submenu {
    position: relative;
}

    .dropdown-submenu > .dropdown-menu {
        -moz-border-radius: 0 6px 6px 6px;
        -webkit-border-radius: 0 6px 6px 6px;
        border-radius: 0 6px 6px 6px;
        left: 100%;
        margin-left: -1px;
        margin-top: -6px;
        top: 0;
    }

    .dropdown-submenu:hover > .dropdown-menu {
        display: block;
    }

    .dropdown-submenu > a:after {
        border-color: transparent;
        border-left-color: #cccccc;
        border-style: solid;
        border-width: 5px 0 5px 5px;
        content: " ";
        display: block;
        float: right;
        height: 0;
        margin-right: -10px;
        margin-top: 5px;
        width: 0;
    }

    .dropdown-submenu:hover > a:after {
        border-left-color: #ffffff;
    }

    .dropdown-submenu.pull-left {
        float: none;
    }

        .dropdown-submenu.pull-left > .dropdown-menu {
            -moz-border-radius: 6px 0 6px 6px;
            -webkit-border-radius: 6px 0 6px 6px;
            border-radius: 6px 0 6px 6px;
            left: -100%;
            margin-left: 10px;
        }

.input-group.date {
    display: inline-block
}

.glyphicon-calendar {
    left: -6px;
    top: -1px;
}

.date .input-group-addon {
    float: right;
    height: 26px;
    margin: 0px 30px 0 -40px;
    position: relative
}

td.acoes-itens {
    border: 0;
    width: 20px;
    font-size: 11px;
}

.sidebar.sidebar-default .sidebar-item > a:hover, .sidebar.sidebar-default .sidebar-item > a:focus {
    color: var(--mu-primaria-texto, #409fff) !important;
}

/* --- Barra do controle de tema no rodape do drawer (MenuPrincipal.tsx) ----
   Ela e \`position: absolute\` ancorada em \`.sidebar\` (que e \`position: fixed\`),
   logo NAO rola junto com a lista — fica parada no rodape enquanto os itens
   passam por baixo. Em tela baixa isso fazia os ultimos itens ("Desdobramento",
   "Ordem de Producao") aparecerem por tras do rotulo "Tema Escuro".

   Duas coisas resolvem, e as duas sao necessarias:
     1. fundo OPACO ocupando a largura toda, para esconder o que passa atras;
     2. \`padding-bottom\` na lista rolavel (regra seguinte), do tamanho da barra,
        para o ultimo item continuar alcancavel em vez de ficar preso embaixo. */
.menu-principal-barra-tema {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px 10px;
    background-color: var(--mu-drawer-fundo, #fff);
    border-top: 1px solid var(--mu-borda-sutil, #eee);
}

/* \`.sidebar-menu\` e quem rola (\`overflow-y: auto\` vem do CSS do sonatra). */
.sidebar.sidebar-ready .sidebar-menu {
    padding-bottom: 52px;
}

#menu-esquerdo {
    border-right: 1px solid var(--mu-borda-sutil, #e5e5e5);
}

.sidebar-collapse .btn-pin {
    width: 50px;
}

.ps-title {
    font-size: 14px;
    color: var(--mu-texto, black);
    letter-spacing: 2px;
    text-transform: uppercase;
    line-height: 24px;
    margin-top: 5px;
}


.wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* css-3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: wrapword;
    white-space: normal;
}

th > .open > .dropdown-menu {
    overflow-y: auto;
    height: 250px;
}



.aviso-processing {
    position: fixed;
    cursor: progress;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(51, 51, 51, 0.7);
    color: white;
    padding: 20px;
    border-radius: 8px;
    min-width: 300px;
    max-width: 80%;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    z-index: 9999;
    overflow: hidden;
    backdrop-filter: blur(2px);
}

.aviso-content {
    cursor: progress;
    position: relative;
    z-index: 2;
}

.aviso-title {
    cursor: progress;
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 10px;
}

.aviso-message {
    cursor: progress;
    display: flex;
    align-items: center;
}

.aviso-border-animation {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, blue 0%, var(--mu-superficie, rgb(255, 255, 255)) 100%);
    background-size: 200% 100%;
    animation: borderFlow 2s linear infinite;
}

@keyframes borderFlow {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

.screen-block-overlay__icone-processando {
    width: 64px;
    height: 64px;
    overflow: hidden;
    cursor: wait;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
}

.screen-block-overlay__icone-processando-gradiente {
    width: 100%;
    height: 100%;
    background: conic-gradient(from 0deg,
        #12627D 0%,
        #3AA8D8 15%,
        #A6E3F7 30%,
        #3AA8D8 45%,
        #12627D 60%,
        #12627D 100%);
    animation: girarCorIconeProcessando 1.6s linear infinite;
}

@keyframes girarCorIconeProcessando {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.botao-flutuante-cesta-produtos {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1040;
    width: 56px;
    height: 56px;
    box-sizing: border-box;
    /* border: 3px solid rgba(0, 0, 0, 0.15);*/
    border-radius: 50%; 
    background-color: var(--mu-primaria, #409fff);
    color: #fff;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.55), 0 3px 8px rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-transition: right 0.3s ease-in-out;
    -o-transition: right 0.3s ease-in-out;
    transition: right 0.3s ease-in-out;
}

.botao-flutuante-cesta-produtos:hover:not(:disabled) {
    filter: brightness(0.92);
}

.botao-flutuante-cesta-produtos:active:not(:disabled) {
    filter: brightness(0.82);
}

.botao-flutuante-cesta-produtos .material-symbols-rounded {
    font-size: 28px;
}

.badge-flutuante-cesta-produtos {
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 10px;
    background-color: #e53935;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

@keyframes botaoFlutuanteCestaProdutosPop {
    0% {
        transform: scale(1);
    }

    30% {
        transform: scale(1.18);
    }

    60% {
        transform: scale(0.94);
    }

    100% {
        transform: scale(1);
    }
}

.botao-flutuante-cesta-produtos--animando {
    animation: botaoFlutuanteCestaProdutosPop 0.9s ease-in-out;
}

/* 491123 — badge de "produto já adicionado" sobre o ícone local_mall de cada linha da grid de
   pesquisa de produtos (itemPesquisaProduto_BadgeLocalMall_*). Círculo sólido com um check branco
   centralizado, pendurado no canto inferior direito da sacola (desenho do mockup da ficha).
   Posicionado relativo ao <button> do ícone, que tem position:relative inline (ver
   ItemPesquisaProduto.tsx) — o wrapper "_relative" externo ancora o dropdown, não o badge.
   Offsets NEGATIVOS deixam o centro do círculo praticamente sobre o canto da sacola, em vez de
   encostado no traço; por isso não há anel branco separando os dois. O <button> não tem
   overflow:hidden (ver botoes.module.scss .botaoIcone), então o transbordo aparece normalmente.
   Mora aqui (CSS global) e não num .module.scss por escolha do autor da ficha. */
.badge-local-mall {
    position: absolute;
    bottom: -1px;
    right: -2px;
    box-sizing: border-box;
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    pointer-events: none;
}

/* Diferente de um .module.scss, aqui o seletor descendente com a classe GLOBAL
   .material-symbols-rounded funciona: neste arquivo nada é hasheado por CSS Modules
   (ver APRENDIZADOS #253, que é justamente o caso oposto). wght maior mantém o traço do
   check legível nesse tamanho; FILL 0 segue o padrão de ícones do projeto (#210). */
.badge-local-mall .material-symbols-rounded {
    font-size: 13px;
    line-height: 1;
    font-variation-settings: 'FILL' 0, 'wght' 700, 'GRAD' 0, 'opsz' 20;
}

/* Produto apenas na cesta — mesmo azul dos ícones de ação do app (base.\$cor-icone no SCSS),
   para o badge combinar com o traço da sacola por baixo. */
.badge-local-mall--azul {
    background-color: #1584e0;
}

/* Produto já existe no orçamento — mesmo verde usado como convenção de "concluído"/"configurado"
   no projeto (ver botaoTintaVerde em ItemPesquisaProduto.module.scss). */
.badge-local-mall--verde {
    background-color: #2E978C;
}

/* ==========================================================================
   Toastr — deixar a FAIXA do container transparente a cliques
   ==========================================================================
   globalMU.showMessage usa positionClass "toast-top-center", e o toastr.css
   vendorizado define:

       .toast-top-center { top: 0; right: 0; width: 100%; }
       #toast-container  { position: fixed; z-index: 999999; }

   Ou seja: o container é uma faixa fixa de LARGURA TOTAL no topo da página, com
   z-index 999999 — mesmo que o toast visível dentro dele tenha só 300px e fique
   centralizado (#toast-container.toast-top-center > div { width: 300px; margin: auto }).
   Como a faixa inteira captura eventos de ponteiro, tudo que fica embaixo dela
   (menu hambúrguer à esquerda, nome/avatar do usuário à direita, abas) ficava
   inclicável enquanto o toast estava na tela.

   Correção: a faixa não recebe eventos (os cliques atravessam para o que está
   atrás) e os toasts em si voltam a receber — preservando o botão de fechar (×),
   o clique-para-dispensar e o :hover que segura o timeout.

   Este arquivo entra pelo main-app.js, que é requerido DEPOIS do main-vendor.js
   (dono do toastr.css) em main.js — então, com a mesma especificidade de ID, o
   override daqui ganha no cascade sem precisar de !important nem de editar o
   arquivo vendorizado em assets/toastr/. */
#toast-container {
    pointer-events: none;
}

#toast-container > div,
#toast-container > .toast {
    pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./Content/estilo.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,qDAAqD;IACrD,gDAAgD;IAChD,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,+BAA+B;IAC/B,kEAAkE;IAClE,0BAA0B;IAC1B,8BAA8B;IAC9B,8EAA8E;AAClF;;AAEA;;yDAEyD;AACzD;IACI,0BAA0B;AAC9B;;;AAGA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qDAAqD;IACrD;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,iEAAiE;IACrE;AACJ;;AAEA;IACI;QACI,iEAAiE;IACrE;AACJ;;AAEA;IACI;QACI,sBAAsB,EAAE,0BAA0B;IACtD;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;IAEI;QACI;IACJ;;AAEJ;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,WAAW;IACX,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,eAAe;IACf,SAAS;IACT,oDAAoD;IACpD,sDAAsD;IACtD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;AACJ;;IAEI;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,8CAA8C;IAClD;;IAEA;;QAEI,wCAAwC;QACxC,qBAAqB;IACzB;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,+CAA+C;IAC/C,uDAAuD;IACvD,kBAAkB;IAClB;AACJ;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,qDAAqD;IACrD,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;IAC9C,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;IAClB,gDAAgD;IAChD,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,yDAAyD;IACzD,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+CAA+C;IAC/C,SAAS;IACT,2CAA2C;IAC3C,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,2EAAgE;IAChE,qDAAqD;IACrD,iDAAiD;IACjD,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yDAA0D;IAC1D;AACJ;;AAEA;IACI,gDAA2C;IAC3C,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI,0CAA0C;QAC1C,iDAAiD;QACjD,wBAAwB;IAC5B;;AAEJ;IACI,uCAAuC;IACvC,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gDAAgD;IAChD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;IAEI;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,uBAAuB;QACvB,YAAY;IAChB;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI,SAAS;QACT,WAAW;QACX,OAAO;QACP,QAAQ;QACR,MAAM;IACV;;AAEJ;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf;AACJ;;AAEA;;kGAEkG;AAClG;;IAEI,iEAAiE;IACjE,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC,+BAA+B;IAC/B,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;;;;;;oCAMoC;AACpC;IACI,4CAA4C;IAC5C,8CAA8C;IAC9C,aAAa;IACb;;2EAEuE;AAC3E;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI,+CAA+C;IACnD;;AAEJ;IACI;AACJ;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qDAAqD;IACrD,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,2BAA2B;IAC3B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,+CAA+C;IAC/C,6HAA6H;IAC7H,+BAA+B;AACnC;;AAEA;IACI,kDAAkD;IAClD,iBAAiB;IACjB,+CAA+C;IAC/C,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI,YAAY;QACZ,qBAAqB;QACrB,iBAAiB;QACjB;IACJ;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4EAA4E;IAC5E,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,uBAAuB;IACvB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,mDAAmD;AACvD;;IAEI;QACI;IACJ;;AAEJ;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI,+CAA+C;IAC/C,4CAA4C;IAC5C,gDAAgD;IAChD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+CAA+C;IAC/C,4BAA4B;IAC5B;AACJ;;AAEA;IACI,wEAAwE;IACxE,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;IAEI;QACI,uBAAuB;IAC3B;;AAEJ;IACI,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB;AACJ;;IAEI;QACI,aAAa;QACb,iCAAiC;QACjC,2BAA2B;QAC3B,WAAW;QACX,WAAW;IACf;;AAEJ;IACI;AACJ;;IAEI;QACI,iCAAiC;QACjC;IACJ;;AAEJ;IACI;AACJ;;AAEA;;;;;GAKG;;AAEH;;GAEG;;AAEH;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,sDAAsD;IACtD,8CAA8C;IAC9C,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,+CAA+C;IAC/C,uFAAuF;IACvF,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI;AACJ;;IAEI;QACI,kBAAkB;QAClB,WAAW;QACX,qBAAqB;QACrB,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;IACf;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,oDAAoD,WAAW;IAC3D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA,oCAAoC,YAAY;IAC5C;AACJ;;AAEA,wCAAwC,YAAY;IAChD;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;AACA,UAAU;;AAEV;IACI;AACJ;AACA,UAAU;;AAEV,YAAY;AACZ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,oBAAoB;IACpB,cAAc;IACd,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB;AACJ;;AAEA;IACI,oDAAoD;IACpD,mDAAmD;IACnD,cAAc;IACd;AACJ;;AAEA;IACI,gDAAgD;IAChD;AACJ;;IAEI;QACI,4CAA4C;QAC5C,SAAS;IACb;;IAEA;QACI,8DAA8D;QAC9D,qCAAqC;QACrC,kBAAkB;QAClB,qBAAqB;QACrB,kBAAkB;IACtB;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA,UAAU;;AAEV;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;IACV,sBAAsB;AAC1B;;IAEI;QACI,6BAA6B;QAC7B,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;IACI;QACI,+CAA+C;QAC/C,SAAS;QACT,uDAAuD;QACvD,yCAAyC;QACzC,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;;QAEI;YACI;QACJ;;QAEA;YACI;QACJ;AACR;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;QACvB,WAAW;QACX,sBAAsB;IAC1B;;QAEI;YACI,6BAA6B;YAC7B,YAAY;YACZ,eAAe;QACnB;AACR;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;QAEI;YACI,sBAAsB;YACtB,WAAW;QACf;AACR;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;QAEI;YACI;QACJ;;YAEI;gBACI;YACJ;;QAEJ;YACI,kBAAkB;YAClB,iBAAiB;QACrB;AACR;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB,eAAe;QACf,SAAS;QACT,UAAU;QACV;IACJ;AACJ;;;AAGA;IACI,mBAAmB;IACnB,yGAAyG;IACzG,oCAAoC;IACpC,uBAAuB;IACvB,sBAAsB;IACtB,uCAAuC;IACvC,eAAe;IACf,6FAA6F;IAC7F,6BAA6B;IAC7B,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;IACZ,YAAY;AAChB;;IAEI;QACI,mBAAmB;QACnB,4CAA4C;QAC5C,wCAAwC;QACxC,yCAAyC;QACzC,uBAAuB;QACvB,sCAAsC;QACtC,sBAAsB;QACtB,uCAAuC;QACvC,YAAY;QACZ,eAAe;QACf,cAAc;QACd,6FAA6F;QAC7F,YAAY;QACZ,6BAA6B;QAC7B,iCAAiC;QACjC,4BAA4B;QAC5B,kBAAkB;QAClB,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,0BAA0B;QAC1B,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,2CAA2C;QAC3C,uCAAuC;QACvC,wCAAwC;QACxC,uBAAuB;QACvB,sCAAsC;QACtC,sBAAsB;QACtB,uCAAuC;QACvC,YAAY;QACZ,eAAe;QACf,cAAc;QACd,6FAA6F;QAC7F,WAAW;QACX,6BAA6B;QAC7B,iCAAiC;QACjC,6BAA6B;QAC7B,kBAAkB;QAClB,UAAU;QACV,gBAAgB;QAChB,SAAS;QACT,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,uBAAuB;QACvB,sBAAsB;QACtB,uCAAuC;QACvC,eAAe;QACf,6FAA6F;QAC7F,YAAY;QACZ,6BAA6B;QAC7B,iCAAiC;QACjC,6BAA6B;QAC7B,2BAA2B;QAC3B,YAAY;IAChB;;QAEI;YACI,gCAAgC;YAChC,uBAAuB;YACvB,sBAAsB;YACtB,uCAAuC;YACvC,cAAc;YACd,gGAAgG;YAChG,YAAY;YACZ,6BAA6B;YAC7B,iCAAiC;YACjC,gBAAgB;YAChB,6BAA6B;YAC7B,kBAAkB;YAClB,gBAAgB;YAChB,qBAAqB;YACrB,2BAA2B;YAC3B,YAAY;QAChB;;YAEI;gBACI,uBAAuB;gBACvB,0BAA0B;gBAC1B,+CAA+C;gBAC/C,qBAAqB;gBACrB,kBAAkB;gBAClB,YAAY;YAChB;;YAEA;gBACI,kFAAkF;gBAClF,oCAAoC;gBACpC,kCAAkC;gBAClC,uBAAuB;gBACvB,sBAAsB;gBACtB,uCAAuC;gBACvC,qBAAqB;gBACrB,gGAAgG;gBAChG,YAAY;gBACZ,6BAA6B;gBAC7B,mBAAmB;gBACnB,iCAAiC;gBACjC,2BAA2B;gBAC3B,gBAAgB;gBAChB,yBAAyB;gBACzB,WAAW;YACf;;YAEA;gBACI,kCAAkC;gBAClC,sCAAsC;gBACtC,uBAAuB;gBACvB,sBAAsB;gBACtB,qBAAqB;gBACrB,8FAA8F;gBAC9F,mBAAmB;gBACnB,6BAA6B;gBAC7B,mBAAmB;gBACnB,gBAAgB;gBAChB,mCAAmC;gBACnC,gBAAgB;gBAChB,yBAAyB;gBACzB,iEAAiE;gBACjE,2CAA2C;gBAC3C,kBAAkB;gBAClB,uBAAuB;gBACvB,yCAAyC;gBACzC,mBAAmB;gBACnB,mBAAmB;gBACnB,WAAW;gBACX,qBAAqB;YACzB;;QAEJ;YACI,wBAAwB;YACxB,YAAY;YACZ,eAAe;YACf,mBAAmB;YACnB,mBAAmB;YACnB,kDAAkD;QACtD;;QAEA;YACI,wBAAwB;YACxB,YAAY;YACZ,eAAe;YACf,mBAAmB;YACnB,mBAAmB;YACnB,sDAAsD;QAC1D;;QAEA;YACI,mBAAmB;YACnB,+GAA+G;YAC/G,gCAAgC;YAChC,uBAAuB;YACvB,YAAY;YACZ,sBAAsB;YACtB,uCAAuC;YACvC,gGAAgG;YAChG,WAAW;YACX,6BAA6B;YAC7B,iCAAiC;YACjC,qCAAqC;YACrC,kBAAkB;YAClB,gBAAgB;YAChB,mCAAmC;YACnC,YAAY;QAChB;;;QAGA;YACI,cAAc;QAClB;;YAEI;gBACI,kFAAkF;gBAClF,oCAAoC;gBACpC,kCAAkC;gBAClC,uBAAuB;gBACvB,sBAAsB;gBACtB,uCAAuC;gBACvC,qBAAqB;gBACrB,gGAAgG;gBAChG,YAAY;gBACZ,6BAA6B;gBAC7B,mBAAmB;gBACnB,iCAAiC;gBACjC,2BAA2B;gBAC3B,gBAAgB;gBAChB,yBAAyB;gBACzB,WAAW;YACf;;YAEA;gBACI,mBAAmB;gBACnB,+GAA+G;gBAC/G,gCAAgC;gBAChC,uBAAuB;gBACvB,YAAY;gBACZ,sBAAsB;gBACtB,uCAAuC;gBACvC,gGAAgG;gBAChG,WAAW;gBACX,6BAA6B;gBAC7B,iCAAiC;gBACjC,qCAAqC;gBACrC,kBAAkB;gBAClB,gBAAgB;gBAChB,mCAAmC;gBACnC,kBAAkB;YACtB;;YAEA;gBACI,YAAY;gBACZ,6CAA6C;gBAC7C,kBAAkB;gBAClB,qBAAqB;gBACrB,eAAe;gBACf,mBAAmB;gBACnB,gBAAgB;gBAChB,eAAe;gBACf,aAAa;gBACb,yBAAyB;gBACzB,mBAAmB;gBACnB,YAAY;YAChB;;IAER;QACI,+GAA+G;QAC/G,gCAAgC;QAChC,uBAAuB;QACvB,sBAAsB;QACtB,uCAAuC;QACvC,eAAe;QACf,uEAAuE;QACvE,YAAY;QACZ,iCAAiC;QACjC,2BAA2B;QAC3B,iBAAiB;QACjB,yBAAyB;QACzB,WAAW;IACf;;QAEI;YACI,kCAAkC;YAClC,8BAA8B;YAC9B,uBAAuB;YACvB,sBAAsB;YACtB,wBAAwB;YACxB,qEAAqE;YACrE,mCAAmC;YACnC,gBAAgB;YAChB,2BAA2B;YAC3B,iBAAiB;YACjB,qBAAqB;YACrB,yBAAyB;QAC7B;;AAER;IACI,gCAAgC;IAChC,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,uEAAuE;IACvE,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;AACjC;;IAEI;QACI,wCAAwC;QACxC,yCAAyC;QACzC,uBAAuB;QACvB,uCAAuC;QACvC,yBAAyB;QACzB,eAAe;QACf,cAAc;QACd,qEAAqE;QACrE,oCAAoC;QACpC,gBAAgB;QAChB,+BAA+B;QAC/B,kBAAkB;QAClB,uBAAuB;QACvB,6BAA6B;QAC7B,mBAAmB;IACvB;;QAEI;YACI,mCAAmC;YACnC,uBAAuB;YACvB,sBAAsB;YACtB,yBAAyB;YACzB,eAAe;YACf,qEAAqE;YACrE,oCAAoC;YACpC,kBAAkB;YAClB,mBAAmB;QACvB;;AAER;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,uEAAuE;IACvE,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,yCAAyC;IACzC,uBAAuB;IACvB,uCAAuC;IACvC,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,qEAAqE;IACrE,oCAAoC;IACpC,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;AACvB;;IAEI;QACI,mCAAmC;QACnC,uBAAuB;QACvB,sBAAsB;QACtB,yBAAyB;QACzB,eAAe;QACf,qEAAqE;QACrE,oCAAoC;QACpC,kBAAkB;QAClB,mBAAmB;IACvB;;AAEJ;IACI,gCAAgC;IAChC,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,uEAAuE;IACvE,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;AACjC;;IAEI;QACI,wCAAwC;QACxC,yCAAyC;QACzC,uBAAuB;QACvB,uCAAuC;QACvC,yBAAyB;QACzB,eAAe;QACf,cAAc;QACd,qEAAqE;QACrE,oCAAoC;QACpC,gBAAgB;QAChB,+BAA+B;QAC/B,kBAAkB;QAClB,uBAAuB;QACvB,6BAA6B;QAC7B,mBAAmB;IACvB;;QAEI;YACI,mCAAmC;YACnC,uBAAuB;YACvB,sBAAsB;YACtB,yBAAyB;YACzB,eAAe;YACf,qEAAqE;YACrE,oCAAoC;YACpC,kBAAkB;YAClB,mBAAmB;QACvB;;AAER;IACI,kBAAkB;AACtB;;IAEI;QACI,iCAAiC;QACjC,oCAAoC;QACpC,4BAA4B;QAC5B,UAAU;QACV,iBAAiB;QACjB,gBAAgB;QAChB,MAAM;IACV;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,mBAAmB;QACnB,2BAA2B;QAC3B,YAAY;QACZ,cAAc;QACd,YAAY;QACZ,SAAS;QACT,mBAAmB;QACnB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;QAEI;YACI,iCAAiC;YACjC,oCAAoC;YACpC,4BAA4B;YAC5B,WAAW;YACX,iBAAiB;QACrB;;AAER;IACI;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;;;;;;;;gFASgF;AAChF;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,8CAA8C;IAC9C,iDAAiD;AACrD;;AAEA,4EAA4E;AAC5E;IACI,oBAAoB;AACxB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,qCAAqC,EAAE,wBAAwB;IAC/D,sBAAsB,EAAE,cAAc;IACtC,wBAAwB,EAAE,YAAY;IACtC,qBAAqB,EAAE,UAAU;IACjC,qBAAqB,EAAE,2BAA2B;IAClD,6BAA6B,EAAE,mCAAmC;IAClE,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iCAAiC;IACjC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,0FAA0F;IAC1F,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,2DAA4D;IAC5D,mDAAoD;IACpD,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;;;;;;qBAMiB;IACjB,wDAAwD;AAC5D;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,6CAA6C;IAC7C,WAAW;IACX,yEAAyE;IACzE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;IAC1C,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;;;;;;;;iFAQiF;AACjF;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;;oFAGoF;AACpF;IACI,eAAe;IACf,cAAc;IACd,kEAAkE;AACtE;;AAEA;2DAC2D;AAC3D;IACI,yBAAyB;AAC7B;;AAEA;yEACyE;AACzE;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;2CAuB2C;AAC3C;IACI,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB","sourcesContent":["*, h4 {\r\n    margin: 0\r\n}\r\n\r\nbody, a, .bootstrap-datetimepicker-widget table {\r\n    color: var(--mu-texto, #333739)\r\n}\r\n\r\nkbd {\r\n    display: inline-block;\r\n    padding: 1px 6px;\r\n    margin: 0 1px;\r\n    font-family: inherit;\r\n    font-size: 0.9em;\r\n    font-weight: 600;\r\n    line-height: 1.5;\r\n    color: var(--mu-texto, #444);\r\n    background-color: var(--mu-superficie-media, #e4e6e8);\r\n    border: 1px solid var(--mu-borda-forte, #a9a9a9);\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 -1px 0 var(--mu-borda-forte, #a9a9a9);\r\n}\r\n\r\nu {\r\n    text-decoration-line: underline;\r\n    text-decoration-color: var(--mu-azul-microuniverso-borda, #43A4D1);\r\n    text-underline-offset: 0px;\r\n    text-underline-position: under;\r\n    filter: drop-shadow(1px 1px 1px var(--mu-sombra-decoracao, rgba(0, 0, 0, .3)));\r\n}\r\n\r\n/* Menu esquerdo \"Endereços\": com offset 0 (padrao do <u>) o sublinhado do\r\n   atalho encosta no rabicho do \"ç\", mesmo com text-underline-position:under.\r\n   So aqui afasta mais para o rabicho aparecer inteiro. */\r\n#orcamento_menu_enderecos_react u {\r\n    text-underline-offset: 3px;\r\n}\r\n\r\n\r\n::-webkit-scrollbar {\r\n    width: 8px;\r\n    height: 10px\r\n}\r\n\r\n::-webkit-scrollbar-button:end:increment,\r\n::-webkit-scrollbar-button:start:decrement {\r\n    display: none\r\n}\r\n\r\n::-webkit-scrollbar-track-piece {\r\n    background-color: var(--mu-superficie-sutil, #f3f3f3);\r\n    -webkit-border-radius: 0px\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-color: #3da3cd;\r\n    -webkit-border-radius: 3px\r\n}\r\n\r\n.bootstrap-datetimepicker-widget {\r\n    z-index: 1030;\r\n}\r\n\r\nbody, html, h4 {\r\n    font: 13px/1.54 arial, sans-serif\r\n}\r\n\r\n.corpo {\r\n    display: table;\r\n    width: 100%\r\n}\r\n\r\np, h2, h3, .msg, .t2, fieldset, .submit {\r\n    margin: 0 0 0.5em\r\n}\r\n\r\ndt, dd {\r\n    font-weight: 400;\r\n    line-height: inherit\r\n}\r\n\r\n.informacaoAdicional {\r\n    color: whitesmoke;\r\n    float: right;\r\n    font-size: x-large;\r\n    max-width: 60%;\r\n    white-space: nowrap;\r\n}\r\n\r\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n    .informacaoAdicional {\r\n        text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\r\n    }\r\n}\r\n\r\n@supports not (mix-blend-mode: screen) {\r\n    .informacaoAdicional {\r\n        text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\r\n    }\r\n}\r\n\r\n@supports (mix-blend-mode: screen) {\r\n    .informacaoAdicional {\r\n        mix-blend-mode: screen; /*difference; hard-light;*/\r\n    }\r\n}\r\n\r\n@font-face {\r\n    font-family: 'microuniverso';\r\n    src: url('microuniverso.eot?#iefix') format('embedded-opentype'), url('microuniverso.woff') format('woff'), url('microuniverso.ttf') format('truetype')\r\n}\r\n\r\n[class*=\"icone-\"]:before {\r\n    display: inline-block;\r\n    margin: 0 8px 0 0;\r\n    vertical-align: top;\r\n}\r\n\r\n[class*=\"fas\"]:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    font-size: 20px;\r\n    margin: 0 8px 0 0;\r\n}\r\n\r\n[class*=\"fab\"]:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    font-size: 20px;\r\n    margin: 0 8px 0 0;\r\n}\r\n\r\n[class*=\"icone-\"]:empty:before {\r\n    margin: 0\r\n}\r\n\r\n[class*=\"icone-\"]:before, .migalha:after {\r\n    -webkit-font-smoothing: antialiased;\r\n    font: 20px/20px microuniverso;\r\n}\r\n\r\n.icone-menu:before {\r\n    content: \"m\";\r\n    margin: 0 2em 0 0\r\n}\r\n\r\n.icone-menu {\r\n    color: #66696b;\r\n    cursor: pointer;\r\n}\r\n\r\n    .icone-menu:hover {\r\n        color: var(--mu-texto, #333739)\r\n    }\r\n\r\n.icone-excluir:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"a\"\r\n}\r\n\r\n.icone-voltar:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"i\"\r\n}\r\n\r\n.icone-erro:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"r\"\r\n}\r\n\r\n.msg:before {\r\n    background: var(--mu-superficie, #fff);\r\n    border-radius: 50%\r\n}\r\n\r\n.icone-incluir:before {\r\n    color: #5ac93c;\r\n    content: \"b\"\r\n}\r\n\r\n.icone-ok:before {\r\n    color: #5ac93c;\r\n    content: \"q\"\r\n}\r\n\r\n.icone-check:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"p\";\r\n    margin: -1px 4px 0 -6px\r\n}\r\n\r\n.icone-check-blue:before {\r\n    color: #0000FF;\r\n    content: \"p\";\r\n    margin: -1px 4px 0 -6px\r\n}\r\n\r\n.icone-pin:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"s\";\r\n    opacity: .2\r\n}\r\n\r\n.icone-pin.ativo:before {\r\n    opacity: 1\r\n}\r\n\r\n.icone-vazio:before {\r\n    opacity: 0;\r\n}\r\n\r\n.icone-acompanhamento:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"x\"\r\n}\r\n\r\n.icone-imagem:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"y\"\r\n}\r\n\r\n.icone-parcelas:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"u\"\r\n}\r\n\r\ntable {\r\n    border-collapse: separate\r\n}\r\n\r\n*, *:before, *:after {\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box\r\n}\r\n\r\n.icone-conf:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"o\"\r\n}\r\n\r\n.icone-selecionar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"g\"\r\n}\r\n\r\n.icone-anterior:before, .icone-proximo:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"i\"\r\n}\r\n\r\n.icone-alerta:before {\r\n    color: #f6f610;\r\n    content: \"G\"\r\n}\r\n\r\n.icone-alerta-critico:before {\r\n    color: #ff0000;\r\n    content: \"G\"\r\n}\r\n\r\n.icone-pagamento:before {\r\n    color: #fcb404;\r\n    content: \"v\"\r\n}\r\n\r\n.icone-proximo:before {\r\n    -webkit-transform: scaleX(-1);\r\n    transform: scaleX(-1);\r\n}\r\n\r\n.icone-credito:before {\r\n    content: \"1\"\r\n}\r\n\r\n.icone-historico:before {\r\n    content: \"2\"\r\n}\r\n\r\n.icone-meta:before {\r\n    content: \"3\"\r\n}\r\n\r\n.icone-pagar:before {\r\n    content: \"4\"\r\n}\r\n\r\n.icone-receber:before {\r\n    content: \"5\"\r\n}\r\n\r\n.icone-disponivel:before {\r\n    content: \"6\"\r\n}\r\n\r\n.icone-baixo:before {\r\n    -webkit-transform: scale(-1, -1);\r\n    content: \"6\";\r\n    transform: scale(-1, -1);\r\n}\r\n\r\n.icone-calculo:before {\r\n    content: \"7\"\r\n}\r\n\r\n.icone-compra:before {\r\n    content: \"8\"\r\n}\r\n\r\n.icone-estoque:before {\r\n    content: \"9\"\r\n}\r\n\r\n.icone-produtocheck:before {\r\n    color: #66696b;\r\n    content: \"q\"\r\n}\r\n\r\n.icone-cor:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"\\e902\"\r\n}\r\n\r\n.icone-orcamento-historico:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"O\"\r\n}\r\n\r\n.icone-orcamento-editar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"n\"\r\n}\r\n\r\n.icone-orcamento-duplicar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"O\"\r\n}\r\n\r\n.icone-orcamento-imagem:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"y\"\r\n}\r\n\r\n.icone-reservar:before {\r\n    color: #5ac93c;\r\n    content: \"V\"\r\n}\r\n\r\n.icone-reservar-faltante:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"V\"\r\n}\r\n\r\n.icone-cor-configurado:before {\r\n    color: #2E978C;\r\n    content: \"\\e902\"\r\n}\r\n\r\n.icone-cor-configurar:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"\\e902\"\r\n}\r\n\r\n.icone-lido:before {\r\n    content: \"\\71\";\r\n    color: #00c800;\r\n}\r\n\r\n.icone-naolido:before {\r\n    content: \"\\71\";\r\n    color: var(--mu-texto-desab, #bbbbbb);\r\n}\r\n\r\n.icone-repetido:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e800\"\r\n}\r\n\r\n.icone-repetido-vermelho:before {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"\\e800\"\r\n}\r\n\r\n.icone-incrementar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\4b\"\r\n}\r\n\r\n.icone-inserir-novo:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\62\"\r\n}\r\n\r\n.icone-email:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"A\"\r\n}\r\n\r\n.ico-whatsapp:before {\r\n    color: #25D366;\r\n    content: \"\\f232\"\r\n}\r\n\r\n.icone-imprimir:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"B\"\r\n}\r\n\r\n.icone-compartilhar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"C\"\r\n}\r\n\r\n.icone-pesquisar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"c\"\r\n}\r\n\r\n.icone-trocar-filial:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"C\"\r\n}\r\n\r\n.icone-info:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"d\"\r\n}\r\n\r\n.icone-comparar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"j\"\r\n}\r\n\r\n.icone-editar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"n\"\r\n}\r\n\r\n.icone-favorito:empty:before {\r\n    color: #daddde;\r\n    content: \"l\";\r\n    margin: 3px 6px 0 0\r\n}\r\n\r\n.icone-favorito.ativo:before {\r\n    color: var(--mu-laranja-texto, #f25713)\r\n}\r\n\r\n.icone-topo:before {\r\n    -webkit-transform: rotate(90deg);\r\n    color: #c5cacb;\r\n    content: \"i\";\r\n    transform: rotate(90deg)\r\n}\r\n\r\n.icone-separar:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"t\"\r\n}\r\n\r\n.icone-opcoes:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"x\"\r\n}\r\n\r\n.icone-seleciona:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"w\"\r\n}\r\n\r\nheader .icone-info:before {\r\n    color: #daddde;\r\n    float: right;\r\n    margin: -1px 0 -1px 10px\r\n}\r\n\r\n.icone-sub:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"f\"\r\n}\r\n\r\n.icone-sugerido:before {\r\n    color: var(--mu-texto-suave, #80888a);\r\n    content: \"\\74\";\r\n}\r\n\r\n.icone-itens:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\6b\"\r\n}\r\n\r\n.icone-cotacoes-perdidas:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\54\"\r\n}\r\n\r\n.icone-faturamento:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\56\"\r\n}\r\n\r\n.icone-home:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e906\"\r\n}\r\n\r\n.icone-office:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e907\"\r\n}\r\n\r\n.icone-usuario:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e977\"\r\n}\r\n\r\n.icone-markup:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"7\";\r\n}\r\n\r\n.icone-pagamentos:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\76\"\r\n}\r\n\r\n.icone-endereco:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e94e\"\r\n}\r\n\r\n.icone-entrega:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e9b6\"\r\n}\r\n\r\n.icone-resumo:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e928\"\r\n}\r\n\r\n.icone-autorizado:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e97b\"\r\n}\r\n\r\n.icone-finalizar-orcamento:before {\r\n    color: #00c800;\r\n    content: \"\\ea17\"\r\n}\r\n\r\n.icone2-frete-peso-cubagem-ativado:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n}\r\n\r\n.icone2-frete-peso-cubagem-desativado:before {\r\n    color: var(--mu-texto-desab, #bbb);\r\n}\r\n\r\n.icone-descontos:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e936\"\r\n}\r\n\r\n.icone-estrela-vazia:before {\r\n    color: var(--mu-texto, #000000);\r\n    content: \"\\e9d7\";\r\n    font-size: small;\r\n}\r\n\r\n.icone-estrela-cheia:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"\\e9d9\";\r\n    font-size: small\r\n}\r\n\r\nli > a.icone-estrela-vazia:hover {\r\n    opacity: 1\r\n}\r\n\r\nli > a.icone-estrela-vazia {\r\n    float: right;\r\n    padding: 0px !important;\r\n    z-index: 0;\r\n    top: -31px;\r\n    width: 20px;\r\n    opacity: 0.2;\r\n}\r\n\r\nli > a.icone-estrela-cheia {\r\n    float: right;\r\n    padding: 0px !important;\r\n    z-index: 0;\r\n    top: -31px;\r\n    width: 20px;\r\n    opacity: 1;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.btn-pin {\r\n    width: 219px;\r\n    transition: width 0.3s;\r\n    position: fixed;\r\n    height: 48px;\r\n    bottom: 0;\r\n    padding: 0 16px;\r\n    border: 0;\r\n    border-top: 1px solid var(--mu-borda-sutil, #e5e5e5);\r\n    border-right: 1px solid var(--mu-borda-sutil, #e5e5e5);\r\n    color: #707070;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: var(--mu-superficie-sutil, #f2f2f2);\r\n}\r\n\r\n.icone-pin-fixo:before {\r\n    content: '\\e905';\r\n    float: left;\r\n    font-size: 30px;\r\n}\r\n\r\n.icone-pin-suspenso:before {\r\n    content: '\\e908';\r\n    float: left;\r\n    font-size: 30px;\r\n}\r\n\r\n.icone-expandido:before {\r\n    color: var(--mu-texto, #000);\r\n    content: '\\e98b';\r\n    font-size: 15px;\r\n}\r\n\r\n.icone-comissoes:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: '\\eaf2';\r\n    font-size: 15px;\r\n}\r\n\r\nh3 .icone-sub:empty:before {\r\n    margin: 3px 8px 0 0\r\n}\r\n\r\nheader .icone-sub:before {\r\n    color: #daddde;\r\n    position: absolute;\r\n    right: -8px;\r\n    top: -3px\r\n}\r\n\r\n.esconde:before {\r\n    -webkit-transform: rotate(-90deg);\r\n    transform: rotate(-90deg)\r\n}\r\n\r\n.icone-lista:before {\r\n    color: var(--mu-azul-texto, #3c8ac9);\r\n    content: \"e\"\r\n}\r\n\r\nheader .icone-lista:before {\r\n    color: #fff;\r\n    margin: 0 2em 0 0;\r\n    opacity: .5\r\n}\r\n\r\n.icone-menu, header .icone-lista {\r\n    float: left;\r\n    overflow: hidden;\r\n    padding: 19px;\r\n    white-space: nowrap;\r\n    width: 58px;\r\n}\r\n\r\nheader .icone-lista {\r\n    padding: 12px 19px\r\n}\r\n\r\n    header .icone-lista:hover:before {\r\n        opacity: .75\r\n    }\r\n\r\n    header .icone-lista:focus:before {\r\n        opacity: .75;\r\n        border: 1px solid black;\r\n    }\r\n\r\n    header .icone-lista.ativo:before {\r\n        opacity: 1\r\n    }\r\n\r\n    header .icone-lista.direita:before {\r\n        display: inline-block;\r\n        transition: color .2s ease, transform .2s ease;\r\n    }\r\n\r\n    header .icone-lista.direita:hover:before,\r\n    header .icone-lista.direita:focus:before {\r\n        color: var(--mu-primaria-texto, #409fff);\r\n        transform: scale(1.2);\r\n    }\r\n\r\nbody, nav .ativo a, .t2 td, .links a:hover {\r\n    background: var(--mu-superficie-sutil, #f2f2f2)\r\n}\r\n\r\n.login .icone-menu:before {\r\n    content: \"h\"\r\n}\r\n\r\n.conf .icone-menu:before {\r\n    content: \"o\"\r\n}\r\n\r\n.menu, .jm, .flut, .inativo:before {\r\n    position: absolute\r\n}\r\n\r\n.menu {\r\n    left: 58px;\r\n    padding: 0 1em 1em;\r\n    z-index: 4\r\n}\r\n\r\n.menu, .jm, .login .geral {\r\n    border: solid var(--mu-borda, #c5cacb);\r\n    border-width: 0 1px 1px;\r\n    box-shadow: 0 0 0 6px rgba(0, 0, 0, .05)\r\n}\r\n\r\n.login .geral {\r\n    border-width: 1px;\r\n    margin: 10% auto;\r\n    width: 442px;\r\n}\r\n\r\n.menu-links a {\r\n    padding: 3px 0\r\n}\r\n\r\n.jm {\r\n    border-width: 1px;\r\n    padding: 8px\r\n}\r\n\r\n.menu-links dl {\r\n    float: left;\r\n    margin: 1em\r\n}\r\n\r\n.usuario {\r\n    background: var(--mu-superficie-sutil, #f6f6f6);\r\n    border-bottom: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    margin: 0 -1em 1em;\r\n    padding: 6px 0 6px 1em\r\n}\r\n\r\n.separador, footer, .final {\r\n    border-top: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    box-shadow: 0 6px rgba(0, 0, 0, .025) inset\r\n}\r\n\r\n.separador {\r\n    padding-top: 2em\r\n}\r\n\r\n.overlay {\r\n    background: rgba(0, 0, 0, .6);\r\n    bottom: 0;\r\n    left: 0;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n\r\n.modal-info {\r\n    left: 4em;\r\n    padding: 2em;\r\n    right: 4em;\r\n    top: 4em;\r\n}\r\n\r\n.modal-conf {\r\n    margin: 33px 0 0 68px;\r\n    width: 200px;\r\n}\r\n\r\n.usuario .direita {\r\n    margin-left: 1em\r\n}\r\n\r\n.usuario a {\r\n    border-left: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    float: left;\r\n    margin: -6px 0;\r\n    padding: 6px 1em;\r\n}\r\n\r\n.login2 h1 {\r\n    color: #fff;\r\n    height: 32px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n}\r\n\r\n.usuario a:hover, .t2 .ativo td, .lista .passo a:before, .pa .ativo {\r\n    background: #f25713;\r\n    color: #fff\r\n}\r\n\r\n.flut {\r\n    right: 1em;\r\n    top: 1em\r\n}\r\n\r\nheader, nav, footer, .menu-links a, .links a {\r\n    display: block\r\n}\r\n\r\n.erro {\r\n    border: 1px solid var(--mu-laranja-borda, #f25713) !important;\r\n    border-color: var(--mu-laranja-borda, #f25713);\r\n    color: var(--mu-laranja-texto, #f25713);\r\n}\r\n\r\n.obrigatorio:after {\r\n    color: var(--mu-laranja-texto, #f25713);\r\n    content: \"*\";\r\n    font-size: 1.4em;\r\n    line-height: 1em;\r\n    margin: 0 0 0 5px;\r\n}\r\n\r\ninput, textarea, select, button:not(.no-global-button):not(.toast-close-button) {\r\n    -moz-box-sizing: border-box;\r\n    border: 1px solid var(--mu-borda, #c5cacb);\r\n    border-radius: 2px;\r\n    box-shadow: 1px 1px 5px rgba(0, 0, 0, .05) inset;\r\n    box-sizing: border-box;\r\n    font: 1em/16px arial, sans-serif;\r\n    padding: 4px;\r\n}\r\n\r\ninput:focus, textarea:focus, select:focus, button:focus:not(.no-global-button):not(.toast-close-button) {\r\n    border-color: var(--mu-azul-microuniverso-borda, #43A4D1);\r\n    outline: none;\r\n}\r\n\r\ninput, textarea, select {\r\n    color: var(--mu-texto, #333333);\r\n}\r\n\r\nselect {\r\n    height: 26px\r\n}\r\n\r\n.direita, header .direita {\r\n    float: right\r\n}\r\n\r\n.legenda {\r\n    padding: 0 19px 0\r\n}\r\n\r\nselect[size] {\r\n    height: auto\r\n}\r\n\r\n.none {\r\n    display: none\r\n}\r\n\r\n.icone-topo.ativo {\r\n    display: block\r\n}\r\n\r\n.icone-topo {\r\n    background: var(--mu-superficie-sutil, #f2f2f2);\r\n    bottom: 0;\r\n    box-shadow: -1px -1px 3px rgba(0, 0, 0, .5);\r\n    padding: .5em;\r\n    position: fixed;\r\n    right: 0\r\n}\r\n\r\n[class*=\"logo-\"]:before {\r\n    float: left;\r\n    margin: 0 1em 0 0;\r\n}\r\n\r\n.logo-cliente:before, .logo-microuniverso:before {\r\n    background: url(images/logo-cliente.png) center center no-repeat;\r\n    border-left: 1px solid var(--mu-borda-sutil, #f2f2f2);\r\n    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.05) inset;\r\n    content: \"\";\r\n    height: 58px;\r\n    margin: -13px 0 0;\r\n    width: 168px;\r\n}\r\n\r\n.logo-microuniverso:before {\r\n    background-image: url(images/logo-microuniverso-login.png);\r\n    width: 220px\r\n}\r\n\r\n.rodape:before {\r\n    content: url(images/logo-microuniverso.png);\r\n    display: inline-block;\r\n    height: 38px;\r\n    margin: 0 1em 0 0;\r\n    vertical-align: middle\r\n}\r\n\r\nnav a, nav li, fieldset label:first-child, .label:first-child, .f2, .f3, .lateral {\r\n    float: left\r\n}\r\n\r\n    nav a:hover {\r\n        background: rgba(0, 0, 0, .12)\r\n    }\r\n\r\nnav ul, .lista-dados {\r\n    overflow: hidden\r\n}\r\n\r\n.t1, .t2, .t3 {\r\n    width: 100%\r\n}\r\n\r\n    .t1 th, .t1 td, .msg {\r\n        border: 1px solid var(--mu-borda, #c5cacb);\r\n        box-shadow: 1px 1px rgba(255, 255, 255, .5) inset;\r\n        padding: 0px 6px 0px 6px;\r\n    }\r\n\r\n.msg {\r\n    background: var(--mu-destaque, #ffdf5f);\r\n    border-color: rgba(0, 0, 0, .1);\r\n    padding: 8px;\r\n}\r\n\r\nheader, fieldset .ob label:first-child, .ob .label:first-child, header .icone-sub, .inativo {\r\n    position: relative\r\n}\r\n\r\n.msg a {\r\n    padding: 4px 10px;\r\n    text-decoration: underline;\r\n}\r\n\r\nfieldset .ob label:first-child:after, .label:first-child:after {\r\n    color: #f03;\r\n    content: \"*\";\r\n    font-size: 18px;\r\n    position: absolute;\r\n    right: 0\r\n}\r\n\r\n.t1 a:hover {\r\n    color: #f03;\r\n    text-decoration: underline\r\n}\r\n\r\n.t1 .selecionado {\r\n    background: rgba(255, 255, 255, .8)\r\n}\r\n\r\n    .t1 .selecionado td {\r\n        box-shadow: 0 -1px rgba(255, 223, 95, .5) inset\r\n    }\r\n\r\n.t1 {\r\n    border-collapse: collapse\r\n}\r\n\r\n.t2, .t3 .t4 {\r\n    border-spacing: 1px\r\n}\r\n\r\n.l {\r\n    border: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    padding: 4px 8px\r\n}\r\n\r\n.pa {\r\n    margin: 0.5em 0 0\r\n}\r\n\r\n.c, .t1 .c {\r\n    text-align: center\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, .ne, .menu dt, .t2 .ativo th, .t3 .destaque {\r\n    font-weight: 700\r\n}\r\n\r\n.msg + .msg {\r\n    border-top: 0;\r\n    margin-top: -16px\r\n}\r\n\r\nfieldset textarea {\r\n    height: 60px;\r\n    overflow: auto;\r\n    width: 75%\r\n}\r\n\r\nfieldset {\r\n    border: 0;\r\n    padding: 0\r\n}\r\n\r\n    fieldset div {\r\n        clear: both;\r\n        margin: 0 0 4px;\r\n        min-height: 26px\r\n    }\r\n\r\n    fieldset label, .label, .d, .t2 td, .t1 .d, .t3 th {\r\n        text-align: right\r\n    }\r\n\r\n    fieldset label, .label {\r\n        font-weight: 400;\r\n        margin: 0;\r\n        padding: 3px 10px 3px 0;\r\n        width: 160px;\r\n    }\r\n\r\n.t2 td, .t3 th, .t3 td {\r\n    padding: 6px\r\n}\r\n\r\n.t3 th {\r\n    width: 192px\r\n}\r\n\r\n.t3 td + td {\r\n    border-left: 1px solid var(--mu-borda-forte, #daddde)\r\n}\r\n\r\n.labeldata {\r\n    font-weight: 400;\r\n    margin: 0;\r\n    padding: 3px 10px 3px 0;\r\n    text-align: left;\r\n    width: 160px;\r\n}\r\n\r\n.lateral {\r\n    clear: none\r\n}\r\n\r\n.lateral, .tam-auto label, [type=\"file\"] {\r\n    width: auto\r\n}\r\n\r\n.tam-selecao {\r\n    width: 31px\r\n}\r\n\r\n.login .submit {\r\n    margin: 0 0 0 70px\r\n}\r\n\r\n.inativo {\r\n    opacity: .5\r\n}\r\n\r\n    .inativo:before {\r\n        bottom: 0;\r\n        content: \"\";\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n    }\r\n\r\n.quebra {\r\n    clear: left\r\n}\r\n\r\n.dica-usuario {\r\n    margin-left: 30px;\r\n    font-size: x-small;\r\n}\r\n\r\n.tpc {\r\n    background-color: var(--mu-superficie-sutil, #e5e7e7) !important;\r\n}\r\n\r\nlabel.tam-1 {\r\n    width: 70px\r\n}\r\n\r\n.tam-1 input, .tam-1 select, .tam-1 textarea {\r\n    width: 60px\r\n}\r\n\r\nlabel.tam-2 {\r\n    width: 110px\r\n}\r\n\r\n.tam-2 input, .tam-2 select, .tam-2 textarea {\r\n    width: 100px\r\n}\r\n\r\nlabel.tam-3 {\r\n    width: 210px\r\n}\r\n\r\n.tam-3 input, .tam-3 select, .tam-3 textarea {\r\n    width: 200px\r\n}\r\n\r\nlabel.tam-4 {\r\n    width: 290px\r\n}\r\n\r\n.tam-4 input, .tam-4 select, .tam-4 textarea {\r\n    width: 280px\r\n}\r\n\r\nlabel.tam-5 {\r\n    width: 370px\r\n}\r\n\r\n.tam-5 input, .tam-5 select, .tam-5 textarea {\r\n    width: 360px\r\n}\r\n\r\nlabel.tam-6 {\r\n    width: 350px\r\n}\r\n\r\n.tam-6 input, .tam-6 select, .tam-6 textarea {\r\n    width: 440px\r\n}\r\n\r\n.tam-max input, .tam-max select, .tam-max textarea {\r\n    width: calc(100% - 10px)\r\n}\r\n\r\n.label-auto label {\r\n    display: block;\r\n    float: none;\r\n    text-align: left;\r\n    width: auto;\r\n}\r\n\r\n.label-radio {\r\n    display: inline-block;\r\n    float: none;\r\n    text-align: left;\r\n    width: auto;\r\n    cursor: pointer;\r\n    /*vertical-align: central;*/\r\n}\r\n\r\n.label-checkbox-dropdown {\r\n    display: inline-block;\r\n    float: none;\r\n    text-align: right;\r\n    width: auto;\r\n    cursor: pointer;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    text-decoration: none;\r\n    padding: 0px 10px 0px 10px;\r\n}\r\n\r\n.checkbox-dropdown {\r\n    display: inline-block;\r\n    float: none;\r\n    text-align: right;\r\n    width: auto;\r\n    cursor: pointer;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    text-decoration: none;\r\n    padding: 0px 10px 0px 10px;\r\n}\r\n\r\n[type=\"checkbox\"], [type=\"radio\"] {\r\n    border: 0;\r\n    height: 15px;\r\n    vertical-align: central;\r\n    cursor: pointer;\r\n    width: 15px !important\r\n}\r\n\r\n/* checkbox/radio nativos (appearance:auto) ignoram border e outline no proprio widget —\r\n   confirmado com screenshot pixel a pixel, nao so getComputedStyle. box-shadow eh a unica\r\n   forma que realmente pinta um anel visivel ao redor deles nesse caso (ver Aprendizado_CSS.md). */\r\n[type=\"checkbox\"]:hover, [type=\"radio\"]:hover,\r\n[type=\"checkbox\"]:focus, [type=\"radio\"]:focus {\r\n    box-shadow: 0 0 0 2px var(--mu-azul-microuniverso-borda, #43A4D1);\r\n    outline: none;\r\n}\r\n\r\nh3, h5, .menu dt {\r\n    font-size: 1.077em;\r\n    line-height: 1.917\r\n}\r\n\r\nh1 {\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, .1);\r\n    font-size: 1.385em;\r\n    line-height: 32px;\r\n    margin: 0;\r\n    padding: 13px;\r\n    white-space: nowrap;\r\n}\r\n\r\nh2:not(.no-global-h2) {\r\n    border-bottom: 1px solid rgba(0, 0, 0, .05);\r\n    font-size: 1.308em;\r\n    line-height: 1.9;\r\n}\r\n\r\n.pa a {\r\n    display: inline-block;\r\n    padding: 2px 9px\r\n}\r\n\r\n.de {\r\n    padding-left: 30px\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button) {\r\n    background: var(--mu-primaria, #409fff);\r\n    border-color: rgba(0, 0, 0, .3);\r\n    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .12) inset;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    text-shadow: 0 1px 1px rgba(0, 0, 0, .3);\r\n    /* width: auto !important; */\r\n}\r\n\r\n/* Foco dos botoes azuis: o anel de foco padrao do navegador e azul e some\r\n   dentro do botao, que tambem e azul. Aqui o foco vira dois sinais somados:\r\n   o fundo escurece para um azul mais fechado E ganha um anel BRANCO por fora,\r\n   com um halo escuro para separar do que estiver atras.\r\n   Usa `:focus` (nao `:focus-visible`) de proposito: o fluxo do sistema navega\r\n   por Enter/Tab mas tambem chega ao botao por clique, e o `:focus-visible`\r\n   nao dispara no clique de mouse. */\r\nbutton:not(.no-global-button):not(.toast-close-button):focus:not(:disabled) {\r\n    background: var(--mu-primaria-foco, #1c78d6);\r\n    border-color: var(--mu-primaria-foco, #1c78d6);\r\n    outline: none;\r\n    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .12) inset,\r\n                0 0 0 2px var(--mu-anel-foco-sobre-azul, #fff),\r\n                0 0 0 3px var(--mu-anel-foco-contorno, rgba(0, 0, 0, 0.45));\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button), .t2 td, .lista a, .pa .ativo, .links a {\r\n    border-radius: 2px\r\n}\r\n\r\n.ordenar.as:after, .ordenar.ds:after {\r\n    border: solid;\r\n    border-color: #80888a transparent;\r\n    border-width: 6px 6px 0;\r\n    content: \"\";\r\n    float: right;\r\n    margin: 7px 0 0 6px\r\n}\r\n\r\n.ordenar.as:after {\r\n    border-width: 0 6px 6px\r\n}\r\n\r\n.ordenar, .clicavel {\r\n    cursor: pointer\r\n}\r\n\r\n    .ordenar:hover {\r\n        box-shadow: 1px 1px 6px rgba(0, 0, 0, .1) inset;\r\n    }\r\n\r\n.rodape:hover:before {\r\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, .1)\r\n}\r\n\r\nlegend {\r\n    border: 0;\r\n    color: var(--mu-texto, #333739);\r\n    display: inline;\r\n    font-size: 1em;\r\n    margin: 0;\r\n    padding: 0 2px\r\n}\r\n\r\n.apresentacao {\r\n    margin: 3em\r\n}\r\n\r\n.secao {\r\n    border-left: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    display: inline-block;\r\n    margin: -13px 0 -13px 1em;\r\n    padding: 13px 26px;\r\n}\r\n\r\n.logo-cliente .secao {\r\n    margin: -13px 0\r\n}\r\n\r\n.login .legenda {\r\n    font-size: 12px;\r\n    line-height: 1em\r\n}\r\n\r\n.secao:before, [class^=\"splash-\"]:before {\r\n    border: solid;\r\n    border-color: var(--mu-borda-sutil, #f2f2f2) transparent;\r\n    border-width: 40px 13px 0 0;\r\n    content: \"\";\r\n    margin: -13px 0 0 -26px;\r\n    position: absolute;\r\n}\r\n\r\n.sub2:after {\r\n    border: solid;\r\n    border-color: var(--mu-borda-forte, #daddde) transparent;\r\n    border-width: 6px 6px 0;\r\n    content: \"\";\r\n    display: inline-block;\r\n    margin: 0 0 0 6px;\r\n    vertical-align: middle\r\n}\r\n\r\nheader .icone-sub {\r\n    margin: 0 19px 0 13px;\r\n    padding: 0 30px 0 13px\r\n}\r\n\r\na:hover, a:focus {\r\n    text-decoration: none\r\n}\r\n\r\nlegend .icone-sub {\r\n    margin: 0 0 0 9px;\r\n    vertical-align: sub\r\n}\r\n\r\nlegend .oculto:before {\r\n    -webkit-transform: rotate(-90deg);\r\n    transform: rotate(-90deg);\r\n}\r\n\r\n.rotate:before {\r\n    -webkit-transform: rotate(-90deg);\r\n    transform: rotate(-90deg);\r\n}\r\n\r\n.submit button:not(.no-global-button):not(.toast-close-button), .submit a {\r\n    display: inline-block;\r\n    margin: 0 3px 0 0;\r\n    padding: 7px 1em;\r\n}\r\n\r\n.submit a {\r\n    padding: 6px 1em\r\n}\r\n\r\n[disabled]:not(.no-global-input) {\r\n    background: var(--mu-superficie-sutil, #f1f2f2);\r\n    border-color: var(--mu-borda, #c5cacb) var(--mu-borda-forte, #daddde) var(--mu-borda-forte, #daddde) var(--mu-borda, #c5cacb);\r\n    color: var(--mu-texto, #333739);\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[disabled] {\r\n    box-shadow: 0 -16px 2px 0 rgba(0, 0, 0, .05) inset;\r\n    text-shadow: none;\r\n    background: var(--mu-superficie-sutil, #f1f2f2);\r\n    color: var(--mu-texto, #333739);\r\n}\r\n\r\nnav a {\r\n    color: #e4e6e8;\r\n    margin: 0 1em;\r\n    padding: 10px 1em\r\n}\r\n\r\nfooter {\r\n    clear: both;\r\n    padding: 1em 2em;\r\n}\r\n\r\nfooter, .menu-links, .legenda, .links a {\r\n    font-size: .923em\r\n}\r\n\r\na {\r\n    text-decoration: none\r\n}\r\n\r\n.migalha {\r\n    margin: 0 5px 0 0\r\n}\r\n\r\n    .migalha:after {\r\n        content: \"g\";\r\n        display: inline-block;\r\n        margin: 0 0 0 9px;\r\n        vertical-align: text-bottom\r\n    }\r\n\r\nfooter, .legenda {\r\n    color: var(--mu-texto-desab, #bbb)\r\n}\r\n\r\n.ma {\r\n    padding: 10px\r\n}\r\n\r\n.lateral {\r\n    margin-right: 10px\r\n}\r\n\r\n[readonly] {\r\n    border-color: var(--mu-borda-media, #e4e6e8)\r\n}\r\n\r\nul {\r\n    margin: 0;\r\n    padding: 0 0 0 15px;\r\n}\r\n\r\nnav ul, nav li, .lista ul, .lista ul, .links, .final {\r\n    box-shadow: none;\r\n    list-style: none;\r\n    padding: 0\r\n}\r\n\r\na.ativo {\r\n    color: var(--mu-texto, #000)\r\n}\r\n\r\nh5, h5 a {\r\n    color: #235987\r\n}\r\n\r\n.final {\r\n    background: linear-gradient(rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));\r\n    margin: 2em -2em -2em;\r\n    padding: 2em\r\n}\r\n\r\nh3, .menu dt, a:hover, .migalha a:hover, .az, .icone-sub:hover:before, .icone-sugerido:hover:before, a.icone-info:hover:before, a.icone-email:hover:before, a.icone-imprimir:hover:before, a.icone-lista:hover:not(.direita):before, a.icone-topo:hover:before, fieldset [class*=\"icone-\"]:hover:before {\r\n    color: var(--mu-primaria-texto, #409fff)\r\n}\r\n\r\n.pa, .tc, .migalha a, .usuario a, header .icone-sub, .secao, .migalha {\r\n    color: var(--mu-texto-suave, #80888a)\r\n}\r\n\r\nlegend {\r\n    color: #5e8eb7\r\n}\r\n\r\n.secao, .t2 th, .t3 th, .login .legenda {\r\n    font-weight: 400\r\n}\r\n\r\nh5 a:hover, .ve {\r\n    color: #f03\r\n}\r\n\r\nnav a:hover, button:not(.no-global-button):not(.toast-close-button) {\r\n    color: #fff\r\n}\r\n\r\n.t1 th {\r\n    background: var(--mu-superficie-forte, #daddde)\r\n}\r\n\r\nth {\r\n    padding: 1px;\r\n    text-align: left;\r\n}\r\n\r\nselect, .menu, header, .t1 tr:hover, .jm, .t3 .destaque, .icone-menu, .contrai:hover {\r\n    background: var(--mu-superficie, #fff)\r\n}\r\n\r\n.t3 .destaque {\r\n    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05)\r\n}\r\n\r\nnav li {\r\n    background-image: none\r\n}\r\n\r\nbutton:active:not([disabled]) {\r\n    background: var(--mu-azul-fundo, #3c8ac9)\r\n}\r\n\r\n.margem {\r\n    margin: 2em;\r\n}\r\n\r\nth.as:after, .ds:after {\r\n    border: solid;\r\n    border-color: rgba(255, 255, 255, .6) transparent;\r\n    border-width: 4px 4px 0;\r\n    float: right;\r\n    margin: 6px 0 0 6px\r\n}\r\n\r\nth.as:after {\r\n    border-width: 0 4px 4px\r\n}\r\n\r\n.lista a, .links a {\r\n    border: 1px solid transparent;\r\n    display: block;\r\n    margin: 0 0 3px;\r\n    padding: 5px 1em;\r\n}\r\n\r\n.links a {\r\n    margin: 0;\r\n    padding: 4px 10px;\r\n}\r\n\r\nimg {\r\n    background: none;\r\n    border: 0\r\n}\r\n\r\ninput::-moz-focus-inner {\r\n    border: 0;\r\n    padding: 0\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"] {\r\n    background: none;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n    color: var(--mu-texto-suave, #80888a);\r\n    text-shadow: 0 1px 1px var(--mu-sombra-texto, #fff);\r\n}\r\n\r\n    button:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"]:before {\r\n        margin: -2px 8px -2px 0\r\n    }\r\n\r\n.margem-filtro {\r\n    margin: 1em 0 0 0\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"]:hover:not([disabled]), .links a:hover {\r\n    background: var(--mu-superficie, #fff);\r\n    border-color: var(--mu-borda-media, #e4e6e8);\r\n    cursor: pointer\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"]:active:not([disabled]), .icone-menu.ativo, .login, .t3 th {\r\n    background: var(--mu-superficie-media, #e4e6e8)\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"]:active:not([disabled]), .icone-menu.ativo, .login, .t3 th {\r\n    background: var(--mu-superficie-media, #e4e6e8)\r\n}\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"][disabled] {\r\n    color: var(--mu-texto-desab, #bbb)\r\n}\r\n\r\n    button:not(.no-global-button):not(.toast-close-button)[class*=\"icone-\"][disabled]:before {\r\n        color: #daddde\r\n    }\r\n\r\nbutton:not(.no-global-button):not(.toast-close-button).ativo:hover:not([disabled]), button:not(.no-global-button).ativo, li.ativo a {\r\n    background: var(--mu-superficie-media, #e4e6e8);\r\n    border-color: var(--mu-borda-forte, #daddde);\r\n    box-shadow: 1px 2px 6px rgba(0, 0, 0, .05) inset;\r\n    color: var(--mu-texto, #000)\r\n}\r\n\r\nfieldset [class*=\"icone-\"]:before {\r\n    margin: 3px 8px 3px 3px\r\n}\r\n\r\nfieldset [class*=\"icone-\"]:empty:before {\r\n    margin: 3px\r\n}\r\n\r\nnav a:after, nav a:before {\r\n    border: solid;\r\n    border-color: transparent;\r\n    border-width: 40px 13px 0 0;\r\n    content: \"\";\r\n    float: left;\r\n    margin: -10px -26px\r\n}\r\n\r\nnav a:after {\r\n    border-width: 40px 0 0 13px;\r\n    float: right\r\n}\r\n\r\nnav a:hover:after, nav a:hover:before {\r\n    border-color: transparent rgba(0, 0, 0, .12)\r\n}\r\n\r\nnav .ativo a:after, nav .ativo a:before {\r\n    border-color: transparent var(--mu-borda-sutil, #f2f2f2)\r\n}\r\n\r\nnav .ativo a {\r\n    background: var(--mu-superficie-sutil, #f2f2f2);\r\n    color: var(--mu-texto, #000);\r\n    text-shadow: 0 1px 1px var(--mu-sombra-texto, #fff)\r\n}\r\n\r\nnav {\r\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .2)) #80888a;\r\n    padding: 5px 13px 0;\r\n}\r\n\r\n.arvore ul {\r\n    list-style: none;\r\n    padding: 0\r\n}\r\n\r\n.arvore li {\r\n    margin: 4px 0;\r\n}\r\n\r\n    .arvore li li {\r\n        margin: 4px 0 4px 1.5em;\r\n    }\r\n\r\n.contrai {\r\n    border: 1px solid rgba(0, 0, 0, .05);\r\n    float: left;\r\n    margin: 0 .5em 0 0;\r\n    padding: 4px 6px\r\n}\r\n\r\n    .contrai:before {\r\n        border: solid;\r\n        border-color: transparent #80888a;\r\n        border-width: 4px 0 4px 4px;\r\n        content: \"\";\r\n        float: left;\r\n    }\r\n\r\n.expandido > .contrai {\r\n    padding: 6px 4px\r\n}\r\n\r\n    .expandido > .contrai:before {\r\n        border-color: #80888a transparent;\r\n        border-width: 4px 4px 0\r\n    }\r\n\r\n.limpo:before {\r\n    border-color: transparent\r\n}\r\n\r\n/* .mapa, .grafico {\r\n    background: url(images/mapa.png);\r\n    border: 1px solid #c5cacb;\r\n    height: 320px;\r\n    margin: 0 0 2em\r\n} */\r\n\r\n/* .grafico {\r\n    background: url(images/grafico.png) center 0 no-repeat #fff\r\n} */\r\n\r\n.lista, .principal, aside {\r\n    display: table-cell;\r\n    vertical-align: top\r\n}\r\n\r\n.lista {\r\n    border-right: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    box-shadow: 1px 0 var(--mu-sombra-texto, #fff);\r\n    padding: 2em 1em;\r\n    width: 227px;\r\n}\r\n\r\naside {\r\n    width: 245px;\r\n    padding: 0px 0px 0px 2em;\r\n}\r\n\r\n.aside {\r\n    padding: 0.5em;\r\n    background: var(--mu-superficie-forte, #daddde);\r\n    box-shadow: 2px 0 6px -2px rgba(0, 0, 0, .2) inset, -1px 0 var(--mu-sombra-texto, #fff);\r\n    min-height: 100%;\r\n}\r\n\r\n.principal {\r\n    padding: 2em;\r\n}\r\n\r\n.lista-dados dl {\r\n    float: left;\r\n    padding: 1em;\r\n    width: 240px\r\n}\r\n\r\n.lista-dados dt {\r\n    float: left;\r\n    font-weight: 700;\r\n    margin: 0 .5em 0 0\r\n}\r\n\r\n    .lista-dados dt:after {\r\n        content: \":\"\r\n    }\r\n\r\n[class*=\"leg-cor-\"] {\r\n    margin: 0 1em 0 0\r\n}\r\n\r\n    [class*=\"leg-cor-\"]:before {\r\n        border-radius: 3px;\r\n        content: \"\";\r\n        display: inline-block;\r\n        height: 16px;\r\n        margin: 0 .5em 0 0;\r\n        vertical-align: sub;\r\n        width: 16px;\r\n    }\r\n\r\n.t1 [class*=\"cor-\"] td:first-child {\r\n    padding-left: 10px\r\n}\r\n\r\n.t1 [class*=\"cor-\"]:not(.cor-0) td {\r\n    background: rgba(255, 255, 255, .5)\r\n}\r\n\r\n.cor-0 td:first-child {\r\n    box-shadow: 4px 0 #e4e6e8 inset\r\n}\r\n\r\n.leg-cor-1:before {\r\n    background: var(--mu-superficie-escura, #BEBEBE)\r\n}\r\n\r\n.cor-1 td:first-child {\r\n    box-shadow: 4px 0 #BEBEBE inset\r\n}\r\n\r\n.leg-cor-2:before {\r\n    background: #f00\r\n}\r\n\r\n.cor-2 td:first-child {\r\n    box-shadow: 4px 0 #f00 inset\r\n}\r\n\r\n.leg-cor-3:before {\r\n    background: var(--mu-destaque, #fc0)\r\n}\r\n\r\n.cor-3 td:first-child {\r\n    box-shadow: 4px 0 #fc0 inset\r\n}\r\n\r\n.leg-cor-4:before {\r\n    background: #0a0\r\n}\r\n\r\n.cor-4 td:first-child {\r\n    box-shadow: 4px 0 #0a0 inset\r\n}\r\n\r\n.leg-cor-5:before {\r\n    background: #11aa99\r\n}\r\n\r\n.cor-5 td:first-child {\r\n    box-shadow: 4px 0 #11aa99 inset\r\n}\r\n\r\n.leg-cor-6:before {\r\n    background: #556b2f\r\n}\r\n\r\n.cor-6 td:first-child {\r\n    box-shadow: 4px 0 #556b2f inset\r\n}\r\n\r\n.leg-cor-7:before {\r\n    background: coral\r\n}\r\n\r\n.cor-7 td:first-child {\r\n    box-shadow: 4px 0 coral inset\r\n}\r\n\r\n.leg-cor-8:before {\r\n    background: darkgoldenrod\r\n}\r\n\r\n.cor-8 td:first-child {\r\n    box-shadow: 4px 0 darkgoldenrod inset\r\n}\r\n\r\n.leg-cor-produto-em-oferta:before {\r\n    background: #0000FF\r\n}\r\n\r\n.cor-produto-em-oferta td:first-child {\r\n    box-shadow: 4px 0 #0000FF inset\r\n}\r\n\r\n.leg-cor-sob-encomenda:before {\r\n    background: #EC780F\r\n}\r\n\r\n.leg-cor-documento-quitado-lucros-e-perdas:before { /*FNX-4896*/\r\n    background: #00C800\r\n}\r\n\r\n.cor-sob-encomenda td:first-child {\r\n    box-shadow: 4px 0 #EC780F inset\r\n}\r\n\r\n.leg-cor-fora-linha:before {\r\n    background: #00C800\r\n}\r\n\r\n.cor-fora-linha td:first-child {\r\n    box-shadow: 4px 0 #00C800 inset\r\n}\r\n\r\n.leg-cor-fora-mix:before {\r\n    background: #800000\r\n}\r\n\r\n.cor-fora-mix td:first-child {\r\n    box-shadow: 4px 0 #800000 inset\r\n}\r\n\r\n.leg-cor-estoque-indisponivel:before {\r\n    background: #FF0000\r\n}\r\n\r\n.cor-estoque-indisponivel td:first-child {\r\n    box-shadow: 4px 0 #FF0000 inset\r\n}\r\n\r\n.leg-cor-entrega-invalida:before {\r\n    background: #FF0080\r\n}\r\n\r\n.cor-entrega-invalida td:first-child {\r\n    box-shadow: 4px 0 #FF0080 inset\r\n}\r\n\r\n.leg-cor-possui-agregado:before {\r\n    background: #808000\r\n}\r\n\r\n.cor-possui-agregado td:first-child {\r\n    box-shadow: 4px 0 #808000 inset\r\n}\r\n\r\n.leg-cor-agregado-promocao:before {\r\n    background: #400080\r\n}\r\n\r\n.cor-agregado-promocao td:first-child {\r\n    box-shadow: 4px 0 #400080 inset\r\n}\r\n\r\n\r\n.leg-cor-produto-importado:before { /* FNX-5558*/\r\n    background: var(--mu-azul-fundo, #3c8ac9)\r\n}\r\n\r\n.cor-produto-importado td:first-child { /* FNX-5558*/\r\n    box-shadow: 4px 0 #3c8ac9 inset\r\n}\r\n\r\n\r\n.leg-cor-retirada-centro-distribuicao:before {\r\n    background: #FF8080\r\n}\r\n\r\n.cor-retirada-centro-distribuicao td:first-child {\r\n    box-shadow: 4px 0 #FF8080 inset\r\n}\r\n\r\n.leg-cor-produto-nao-aceita-devolucao:before {\r\n    background: var(--mu-destaque, #FFFF00)\r\n}\r\n\r\n.cor-produto-nao-aceita-devolucao td:first-child {\r\n    box-shadow: 4px 0 #FFFF00 inset\r\n}\r\n\r\n.leg-cor-cotacao-perdida:before {\r\n    background: #808080\r\n}\r\n\r\n.cor-cotacao-perdida td:first-child {\r\n    box-shadow: 4px 0 #808080 inset\r\n}\r\n\r\n.leg-cor-oferta-agregado:before {\r\n    background: #8000FF\r\n}\r\n\r\n.cor-oferta-agregado td:first-child {\r\n    box-shadow: 4px 0 #8000FF inset\r\n}\r\n\r\n.leg-cor-todos-enderecos:before {\r\n    background: var(--mu-superficie-escura, #C0C0C0)\r\n}\r\n\r\n.cor-todos-enderecos td:first-child {\r\n    box-shadow: 4px 0 #C0C0C0 inset\r\n}\r\n\r\n.leg-cor-faturamento-entrega-enderecos:before {\r\n    background: #FF8000\r\n}\r\n\r\n.cor-faturamento-entrega-enderecos td:first-child {\r\n    box-shadow: 4px 0 #FF8000 inset\r\n}\r\n\r\n.leg-cor-cobranca-entrega-enderecos:before {\r\n    background: #000000\r\n}\r\n\r\n.cor-cobranca-entrega-enderecos td:first-child {\r\n    box-shadow: 4px 0 #000000 inset\r\n}\r\n\r\n.leg-cor-faturamento-cobranca-enderecos:before {\r\n    background: #800000\r\n}\r\n\r\n.cor-faturamento-cobranca-enderecos td:first-child {\r\n    box-shadow: 4px 0 #800000 inset\r\n}\r\n\r\n.leg-cor-entrega-enderecos:before {\r\n    background: #FF0000\r\n}\r\n\r\n.cor-entrega-enderecos td:first-child {\r\n    box-shadow: 4px 0 #FF0000 inset\r\n}\r\n\r\n.leg-cor-cobranca-enderecos:before {\r\n    background: #0000FF\r\n}\r\n\r\n.cor-cobranca-enderecos td:first-child {\r\n    box-shadow: 4px 0 #0000FF inset\r\n}\r\n\r\n.leg-cor-faturamento-enderecos:before {\r\n    background: #00FF00\r\n}\r\n\r\n.cor-faturamento-enderecos td:first-child {\r\n    box-shadow: 4px 0 #00FF00 inset\r\n}\r\n\r\n.cor-cancelamento-nao-pode-ser-cancelado td:first-child {\r\n    box-shadow: 4px 0 #800000 inset\r\n}\r\n/*FNX-970*/\r\n\r\n.leg-cor-cancelamento-nao-pode-ser-cancelado:before {\r\n    background: #FF0000\r\n}\r\n/*FNX-970*/\r\n\r\n/*manut-301*/\r\n.leg-cor-DisponibilidadeCarga-DataDisponivel:before {\r\n    background: blue\r\n}\r\n\r\n.cor-DisponibilidadeCarga-DataDisponivel td:first-child {\r\n    box-shadow: 4px 0 blue inset\r\n}\r\n\r\n.leg-cor-DisponibilidadeCarga-SemCadastro:before {\r\n    background: green\r\n}\r\n\r\n.cor-DisponibilidadeCarga-SemCadastro td:first-child {\r\n    box-shadow: 4px 0 green inset\r\n}\r\n\r\n.leg-cor-DisponibilidadeCarga-DataIndisponivel:before {\r\n    background: red\r\n}\r\n\r\n.cor-DisponibilidadeCarga-DataIndisponivel td:first-child {\r\n    box-shadow: 4px 0 red inset\r\n}\r\n\r\n\r\n.splash {\r\n    border-spacing: 10px;\r\n    display: table;\r\n    width: 100%;\r\n}\r\n\r\n.linha {\r\n    display: table-row\r\n}\r\n\r\n.splash dl {\r\n    background: var(--mu-superficie, #fff);\r\n    border-radius: 4px;\r\n    box-shadow: 1px 2px 6px rgba(0, 0, 0, .05) inset;\r\n    display: table-cell;\r\n    width: 25%\r\n}\r\n\r\n.splash a {\r\n    border-top: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    box-shadow: 0 6px 6px -4px rgba(0, 0, 0, .05) inset;\r\n    display: block;\r\n    padding: 12px\r\n}\r\n\r\n[class^=\"splash-\"] {\r\n    border: 1px solid var(--mu-borda-media, #e4e6e8);\r\n    border-top: 3px solid var(--mu-laranja-borda, #f25713)\r\n}\r\n\r\n    [class^=\"splash-\"]:before {\r\n        border-color: rgba(0, 0, 0, .02) transparent;\r\n        margin: 0;\r\n    }\r\n\r\n    [class^=\"splash-\"] dt {\r\n        /* background: url(../img/splash.svg) center 30px no-repeat; */\r\n        color: var(--mu-texto-suave, #80888a);\r\n        font-size: 1.385em;\r\n        padding: 120px 0 20px;\r\n        text-align: center;\r\n    }\r\n\r\n.splash-vendas dt {\r\n    background-position: center -170px\r\n}\r\n\r\n.splash-vendas {\r\n    border-top-color: #5ac93c\r\n}\r\n\r\n.splash-financeiro dt {\r\n    background-position: center -370px\r\n}\r\n\r\n.splash-financeiro {\r\n    border-top-color: #fcb404\r\n}\r\n\r\n.splash-ti dt {\r\n    background-position: center -570px\r\n}\r\n\r\n.splash-ti {\r\n    border-top-color: var(--mu-primaria-borda, #409fff)\r\n}\r\n\r\n.splash-compras [class^=\"icone-\"]:before {\r\n    color: var(--mu-laranja-texto, #f25713)\r\n}\r\n\r\n.splash-vendas [class^=\"icone-\"]:before {\r\n    color: #5ac93c\r\n}\r\n\r\n.splash-financeiro [class^=\"icone-\"]:before {\r\n    color: #fcb404\r\n}\r\n\r\n.splash-ti [class^=\"icone-\"]:before {\r\n    color: var(--mu-primaria-texto, #409fff)\r\n}\r\n\r\n.splash [class^=\"icone-\"]:hover:before, .splash [class^=\"icone-\"]:hover {\r\n    color: var(--mu-texto, #333739) !important\r\n}\r\n\r\n\r\n/* temas */\r\n\r\n.wiz ul {\r\n    counter-reset: item\r\n}\r\n\r\n.wiz li a:before {\r\n    border-radius: 2px;\r\n    color: var(--mu-texto-desab, #bbb);\r\n    content: counter(item);\r\n    counter-increment: item;\r\n    float: left;\r\n    line-height: 24px;\r\n    margin: -2px 6px -2px -10px;\r\n    text-align: center;\r\n    width: 24px;\r\n}\r\n\r\n.fieldset-box {\r\n    border: 1px solid;\r\n    border-color: lightgrey;\r\n    width: 40%;\r\n    padding: 2px 0 5px 0px;\r\n}\r\n\r\n    .fieldset-box > legend {\r\n        color: var(--mu-texto, black);\r\n        border: none;\r\n        width: 130px;\r\n        text-align: center;\r\n    }\r\n\r\n@media screen and (max-width: 1200px) {\r\n    .lista {\r\n        background: var(--mu-superficie-sutil, #f2f2f2);\r\n        border: 0;\r\n        border-bottom: 1px solid var(--mu-borda-media, #e4e6e8);\r\n        box-shadow: 0 1px rgba(255, 255, 255, .5);\r\n        display: table-caption;\r\n        overflow: hidden;\r\n        padding: 1em;\r\n        width: auto;\r\n    }\r\n\r\n        .lista a {\r\n            margin: 0 .5em 0 0\r\n        }\r\n\r\n        .lista li, .lista a {\r\n            float: left\r\n        }\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n    .lateral {\r\n        float: none;\r\n        margin-right: 0\r\n    }\r\n\r\n    label.tam-1, label.tam-2, label.tam-3, label.tam-4, label.tam-5 {\r\n        width: 150px\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 900px) and (min-width: 700px) {\r\n    .splash [class*=\"icone-\"]:before {\r\n        display: block;\r\n        margin: 0 0 8px;\r\n        width: 20px\r\n    }\r\n\r\n    .fieldset-box {\r\n        border: 1px solid;\r\n        border-color: lightgrey;\r\n        width: 100%;\r\n        padding: 2px 0 5px 5px;\r\n    }\r\n\r\n        .fieldset-box > legend {\r\n            color: var(--mu-texto, black);\r\n            border: none;\r\n            margin-left: 0%;\r\n        }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n    fieldset label, fieldset label:first-child, label.tam-1, label.tam-2, label.tam-3, label.tam-4, label.tam-5, .lista-dados dl {\r\n        display: block;\r\n        float: none;\r\n        text-align: left;\r\n        width: auto;\r\n    }\r\n\r\n    .legenda {\r\n        display: none\r\n    }\r\n\r\n    .splash, .linha, .splash dl {\r\n        display: block\r\n    }\r\n\r\n        .splash dl {\r\n            margin: 10px 10px 20px;\r\n            width: auto;\r\n        }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n    fieldset label:first-child {\r\n        display: block;\r\n        float: none;\r\n        text-align: left;\r\n        width: auto\r\n    }\r\n\r\n    input, select, textarea {\r\n        width: calc(100% - 13px) !important\r\n    }\r\n\r\n    .responsiv {\r\n        overflow: auto\r\n    }\r\n\r\n    .principal, aside {\r\n        display: block;\r\n    }\r\n\r\n    [class*=\"logo-\"]:before {\r\n        display: none\r\n    }\r\n\r\n    nav, .lista {\r\n        padding: 4px\r\n    }\r\n\r\n        nav a, .lista a {\r\n            margin: 1px\r\n        }\r\n\r\n            nav a:after, nav a:before, nav li:after, nav li:before {\r\n                content: none\r\n            }\r\n\r\n        nav a {\r\n            border-radius: 2px;\r\n            padding: 8px 12px;\r\n        }\r\n}\r\n\r\n@media print {\r\n    nav ul, .submit, footer, .no-im {\r\n        display: none\r\n    }\r\n\r\n    .corpo {\r\n        padding: 10px 0 0\r\n    }\r\n\r\n    h1 {\r\n        padding: 0 0 10px\r\n    }\r\n\r\n    h1, h2 {\r\n        color: var(--mu-texto, #000)\r\n    }\r\n\r\n    header {\r\n        border-bottom: 1px solid;\r\n        margin: 0 0 10px\r\n    }\r\n\r\n    header, .t1 th {\r\n        border-color: var(--mu-borda, #c5cacb)\r\n    }\r\n\r\n    h1:before {\r\n        border: 0;\r\n        content: \"PMMG - \";\r\n        display: inline;\r\n        margin: 0;\r\n        padding: 0;\r\n        vertical-align: inherit\r\n    }\r\n}\r\n\r\n\r\n.ambiente-menu {\r\n    align-self: stretch;\r\n    background: var(--mu-superficie, rgb(255, 255, 255)) none repeat scroll 0% 0%/auto padding-box border-box;\r\n    border: 1px solid rgb(197, 198, 200);\r\n    border-spacing: 1px 1px;\r\n    box-sizing: border-box;\r\n    color: var(--mu-texto, rgb(51, 51, 51));\r\n    cursor: pointer;\r\n    font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n    list-style: none outside none;\r\n    margin: 0px;\r\n    outline: rgb(51, 51, 51) none 0px;\r\n    padding: 1px;\r\n    perspective-origin: 96px 212px;\r\n    position: absolute;\r\n    text-align: left;\r\n    transform-origin: 96px 212px;\r\n    width: 200px;\r\n    z-index: 150;\r\n}\r\n\r\n    .ambiente-menu:before {\r\n        align-self: stretch;\r\n        border-bottom: 10px solid rgb(197, 198, 200);\r\n        border-left: 10px solid rgba(0, 0, 0, 0);\r\n        border-right: 10px solid rgba(0, 0, 0, 0);\r\n        border-spacing: 1px 1px;\r\n        border-top: 0px solid rgba(0, 0, 0, 0);\r\n        box-sizing: border-box;\r\n        color: var(--mu-texto, rgb(51, 51, 51));\r\n        content: ' ';\r\n        cursor: pointer;\r\n        display: block;\r\n        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n        height: 10px;\r\n        list-style: none outside none;\r\n        outline: rgb(51, 51, 51) none 0px;\r\n        perspective-origin: 10px 5px;\r\n        position: absolute;\r\n        right: 5px;\r\n        text-align: left;\r\n        top: -10px;\r\n        transform-origin: 10px 5px;\r\n        width: 20px;\r\n    }\r\n\r\n    .ambiente-menu:after {\r\n        align-self: stretch;\r\n        border-bottom: 9px solid rgb(255, 255, 255);\r\n        border-left: 9px solid rgba(0, 0, 0, 0);\r\n        border-right: 9px solid rgba(0, 0, 0, 0);\r\n        border-spacing: 1px 1px;\r\n        border-top: 0px solid rgba(0, 0, 0, 0);\r\n        box-sizing: border-box;\r\n        color: var(--mu-texto, rgb(51, 51, 51));\r\n        content: ' ';\r\n        cursor: pointer;\r\n        display: block;\r\n        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n        height: 9px;\r\n        list-style: none outside none;\r\n        outline: rgb(51, 51, 51) none 0px;\r\n        perspective-origin: 9px 4.5px;\r\n        position: absolute;\r\n        right: 6px;\r\n        text-align: left;\r\n        top: -9px;\r\n        transform-origin: 9px 4.5px;\r\n        width: 18px;\r\n    }\r\n\r\n    .ambiente-menu .menu-item {\r\n        border: 0px none rgb(51, 51, 51);\r\n        border-spacing: 1px 1px;\r\n        box-sizing: border-box;\r\n        color: var(--mu-texto, rgb(51, 51, 51));\r\n        cursor: pointer;\r\n        font: normal normal 300 normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n        height: 36px;\r\n        list-style: none outside none;\r\n        outline: rgb(51, 51, 51) none 0px;\r\n        perspective-origin: 94px 18px;\r\n        transform-origin: 94px 18px;\r\n        width: 196px;\r\n    }\r\n\r\n        .ambiente-menu .menu-item a.link {\r\n            border: 0px none rgb(51, 51, 51);\r\n            border-spacing: 1px 1px;\r\n            box-sizing: border-box;\r\n            color: var(--mu-texto, rgb(51, 51, 51));\r\n            display: block;\r\n            font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n            height: 36px;\r\n            list-style: none outside none;\r\n            outline: rgb(51, 51, 51) none 0px;\r\n            padding: 2px 5px;\r\n            perspective-origin: 94px 18px;\r\n            position: relative;\r\n            text-align: left;\r\n            text-decoration: none;\r\n            transform-origin: 94px 18px;\r\n            width: 196px;\r\n        }\r\n\r\n            .ambiente-menu .menu-item a.link:hover {\r\n                -moz-border-radius: 2px;\r\n                -webkit-border-radius: 2px;\r\n                background: var(--mu-superficie-sutil, #f2f3f2);\r\n                border-color: #f2f3f2;\r\n                border-radius: 2px;\r\n                color: white;\r\n            }\r\n\r\n            .ambiente-menu .menu-item a.link .dot {\r\n                background: rgb(253, 171, 61) none repeat scroll 0% 0%/auto padding-box border-box;\r\n                border: 1px solid rgb(197, 198, 200);\r\n                border-radius: 100% 100% 100% 100%;\r\n                border-spacing: 1px 1px;\r\n                box-sizing: border-box;\r\n                color: var(--mu-texto, rgb(51, 51, 51));\r\n                display: inline-block;\r\n                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n                height: 16px;\r\n                list-style: none outside none;\r\n                margin: 8px 0px 3px;\r\n                outline: rgb(51, 51, 51) none 0px;\r\n                perspective-origin: 8px 8px;\r\n                text-align: left;\r\n                transform-origin: 8px 8px;\r\n                width: 16px;\r\n            }\r\n\r\n            .ambiente-menu .menu-item a.link .label {\r\n                border: 0px none rgb(253, 171, 61);\r\n                border-radius: 3.5px 3.5px 3.5px 3.5px;\r\n                border-spacing: 1px 1px;\r\n                box-sizing: border-box;\r\n                display: inline-block;\r\n                font: normal normal normal normal 14px/25px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n                height: 31.984375px;\r\n                list-style: none outside none;\r\n                margin: 1px 0px 0px;\r\n                max-width: 170px;\r\n                outline: rgb(253, 171, 61) none 0px;\r\n                overflow: hidden;\r\n                overflow-wrap: break-word;\r\n                padding: 2.79999995231628px 8.39999961853027px 4.19999980926514px;\r\n                perspective-origin: 55.890625px 15.984375px;\r\n                text-align: center;\r\n                text-overflow: ellipsis;\r\n                transform-origin: 55.890625px 15.984375px;\r\n                vertical-align: top;\r\n                white-space: nowrap;\r\n                width: 100%;\r\n                word-wrap: break-word;\r\n            }\r\n\r\n        .ambiente-menu .menu-item .edit {\r\n            color: rgb(82, 151, 239);\r\n            float: right;\r\n            font-size: 14px;\r\n            height: 31.984375px;\r\n            margin: 1px 0px 0px;\r\n            padding: 2.79999995231628px 4px 4.19999980926514px;\r\n        }\r\n\r\n        .ambiente-menu .menu-item .delete {\r\n            color: rgb(82, 151, 239);\r\n            float: right;\r\n            font-size: 14px;\r\n            height: 31.984375px;\r\n            margin: 1px 0px 0px;\r\n            padding: 2.79999995231628px 2px 4.19999980926514px 8px;\r\n        }\r\n\r\n        .ambiente-menu .menu-item a.link .separator {\r\n            align-self: stretch;\r\n            background: var(--mu-superficie-sutil, rgb(224, 229, 225)) none repeat scroll 0% 0%/auto padding-box border-box;\r\n            border: 0px none rgb(51, 51, 51);\r\n            border-spacing: 1px 1px;\r\n            bottom: -1px;\r\n            box-sizing: border-box;\r\n            color: var(--mu-texto, rgb(51, 51, 51));\r\n            font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n            height: 1px;\r\n            list-style: none outside none;\r\n            outline: rgb(51, 51, 51) none 0px;\r\n            perspective-origin: 88.359375px 0.5px;\r\n            position: absolute;\r\n            text-align: left;\r\n            transform-origin: 88.359375px 0.5px;\r\n            width: 184px;\r\n        }\r\n\r\n\r\n        .ambiente-menu .menu-item .color-label {\r\n            display: block;\r\n        }\r\n\r\n            .ambiente-menu .menu-item .color-label .dot {\r\n                background: rgb(253, 171, 61) none repeat scroll 0% 0%/auto padding-box border-box;\r\n                border: 1px solid rgb(197, 198, 200);\r\n                border-radius: 100% 100% 100% 100%;\r\n                border-spacing: 1px 1px;\r\n                box-sizing: border-box;\r\n                color: var(--mu-texto, rgb(51, 51, 51));\r\n                display: inline-block;\r\n                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n                height: 16px;\r\n                list-style: none outside none;\r\n                margin: 8px 0px 3px;\r\n                outline: rgb(51, 51, 51) none 0px;\r\n                perspective-origin: 8px 8px;\r\n                text-align: left;\r\n                transform-origin: 8px 8px;\r\n                width: 16px;\r\n            }\r\n\r\n            .ambiente-menu .menu-item .color-label .separator {\r\n                align-self: stretch;\r\n                background: var(--mu-superficie-sutil, rgb(224, 229, 225)) none repeat scroll 0% 0%/auto padding-box border-box;\r\n                border: 0px none rgb(51, 51, 51);\r\n                border-spacing: 1px 1px;\r\n                bottom: -1px;\r\n                box-sizing: border-box;\r\n                color: var(--mu-texto, rgb(51, 51, 51));\r\n                font: normal normal normal normal 13px/19.5px 'Trebuchet MS', Tahoma, Verdana, Arial, sans-serif;\r\n                height: 1px;\r\n                list-style: none outside none;\r\n                outline: rgb(51, 51, 51) none 0px;\r\n                perspective-origin: 88.359375px 0.5px;\r\n                position: absolute;\r\n                text-align: left;\r\n                transform-origin: 88.359375px 0.5px;\r\n                width: 176.71875px;\r\n            }\r\n\r\n            .ambiente-menu .menu-item .color-label .input {\r\n                border: none;\r\n                border: 1px solid var(--mu-borda-media, #ddd);\r\n                border-radius: 3px;\r\n                display: inline-block;\r\n                font-size: 14px;\r\n                font-weight: normal;\r\n                margin-left: 5px;\r\n                margin-top: 7px;\r\n                outline: none;\r\n                padding: 3px 3px 3px 10px;\r\n                vertical-align: top;\r\n                width: 128px;\r\n            }\r\n\r\n    .ambiente-menu .menu-item-acoes {\r\n        background: var(--mu-superficie-sutil, rgb(246, 248, 250)) none repeat scroll 0% 0%/auto padding-box border-box;\r\n        border: 0px none rgb(51, 51, 51);\r\n        border-spacing: 1px 1px;\r\n        box-sizing: border-box;\r\n        color: var(--mu-texto, rgb(51, 51, 51));\r\n        cursor: pointer;\r\n        font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;\r\n        height: auto;\r\n        outline: rgb(51, 51, 51) none 0px;\r\n        perspective-origin: 50% 50%;\r\n        text-align: right;\r\n        transform-origin: 50% 50%;\r\n        width: auto;\r\n    }\r\n\r\n        .ambiente-menu .menu-item-acoes .link {\r\n            border: 0px none rgb(82, 151, 239);\r\n            border-radius: 3px 3px 3px 3px;\r\n            border-spacing: 1px 1px;\r\n            box-sizing: border-box;\r\n            color: rgb(82, 151, 239);\r\n            font: normal normal 300 normal 12px/25px helvetica, arial, sans-serif;\r\n            outline: rgb(82, 151, 239) none 0px;\r\n            padding: 2px 5px;\r\n            perspective-origin: 50% 50%;\r\n            text-align: right;\r\n            text-decoration: none;\r\n            transform-origin: 50% 50%;\r\n        }\r\n\r\n.ambiente-col {\r\n    border: 0px none rgb(51, 51, 51);\r\n    border-spacing: 1px 1px;\r\n    color: var(--mu-texto, rgb(51, 51, 51));\r\n    cursor: pointer;\r\n    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;\r\n    outline: rgb(51, 51, 51) none 0px;\r\n    perspective-origin: 71.5px 18px;\r\n    position: relative;\r\n    transform-origin: 71.5px 18px;\r\n}\r\n\r\n    .ambiente-col .color {\r\n        border-left: 0px none rgb(255, 255, 255);\r\n        border-right: 0px none rgb(255, 255, 255);\r\n        border-spacing: 1px 1px;\r\n        border-top: 0px none rgb(255, 255, 255);\r\n        color: rgb(255, 255, 255);\r\n        cursor: pointer;\r\n        display: block;\r\n        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n        outline: rgb(255, 255, 255) none 0px;\r\n        overflow: hidden;\r\n        perspective-origin: 71.5px 18px;\r\n        text-align: center;\r\n        text-overflow: ellipsis;\r\n        transform-origin: 71.5px 18px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n        .ambiente-col .color span.text {\r\n            border: 0px none rgb(255, 255, 255);\r\n            border-spacing: 1px 1px;\r\n            box-sizing: border-box;\r\n            color: rgb(255, 255, 255);\r\n            cursor: pointer;\r\n            font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n            outline: rgb(255, 255, 255) none 0px;\r\n            text-align: center;\r\n            white-space: nowrap;\r\n        }\r\n\r\n.ambientes-separados {\r\n    color: var(--mu-texto, #000000);\r\n    list-style: none;\r\n}\r\n\r\n.inconsistencias {\r\n    color: var(--mu-texto, #000000);\r\n    list-style: none;\r\n}\r\n\r\n.centro-custo-col {\r\n    border: 0px none rgb(51, 51, 51);\r\n    border-spacing: 1px 1px;\r\n    color: var(--mu-texto, rgb(51, 51, 51));\r\n    cursor: pointer;\r\n    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;\r\n    outline: rgb(51, 51, 51) none 0px;\r\n    perspective-origin: 71.5px 18px;\r\n    position: relative;\r\n    transform-origin: 71.5px 18px;\r\n}\r\n\r\n.filial-item-col .color {\r\n    border-left: 0px none rgb(255, 255, 255);\r\n    border-right: 0px none rgb(255, 255, 255);\r\n    border-spacing: 1px 1px;\r\n    border-top: 0px none rgb(255, 255, 255);\r\n    color: rgb(255, 255, 255);\r\n    cursor: pointer;\r\n    display: block;\r\n    font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n    outline: rgb(255, 255, 255) none 0px;\r\n    overflow: hidden;\r\n    perspective-origin: 71.5px 18px;\r\n    text-align: center;\r\n    text-overflow: ellipsis;\r\n    transform-origin: 71.5px 18px;\r\n    white-space: nowrap;\r\n}\r\n\r\n    .filial-item-col .color span.text {\r\n        border: 0px none rgb(255, 255, 255);\r\n        border-spacing: 1px 1px;\r\n        box-sizing: border-box;\r\n        color: rgb(255, 255, 255);\r\n        cursor: pointer;\r\n        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n        outline: rgb(255, 255, 255) none 0px;\r\n        text-align: center;\r\n        white-space: nowrap;\r\n    }\r\n\r\n.centro-custo-col {\r\n    border: 0px none rgb(51, 51, 51);\r\n    border-spacing: 1px 1px;\r\n    color: var(--mu-texto, rgb(51, 51, 51));\r\n    cursor: pointer;\r\n    font: normal normal 300 normal 13px/19.5px helvetica, arial, sans-serif;\r\n    outline: rgb(51, 51, 51) none 0px;\r\n    perspective-origin: 71.5px 18px;\r\n    position: relative;\r\n    transform-origin: 71.5px 18px;\r\n}\r\n\r\n    .centro-custo-col .color {\r\n        border-left: 0px none rgb(255, 255, 255);\r\n        border-right: 0px none rgb(255, 255, 255);\r\n        border-spacing: 1px 1px;\r\n        border-top: 0px none rgb(255, 255, 255);\r\n        color: rgb(255, 255, 255);\r\n        cursor: pointer;\r\n        display: block;\r\n        font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n        outline: rgb(255, 255, 255) none 0px;\r\n        overflow: hidden;\r\n        perspective-origin: 71.5px 18px;\r\n        text-align: center;\r\n        text-overflow: ellipsis;\r\n        transform-origin: 71.5px 18px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n        .centro-custo-col .color span.text {\r\n            border: 0px none rgb(255, 255, 255);\r\n            border-spacing: 1px 1px;\r\n            box-sizing: border-box;\r\n            color: rgb(255, 255, 255);\r\n            cursor: pointer;\r\n            font: normal normal 300 normal 12px/18px helvetica, arial, sans-serif;\r\n            outline: rgb(255, 255, 255) none 0px;\r\n            text-align: center;\r\n            white-space: nowrap;\r\n        }\r\n\r\n.dropdown-submenu {\r\n    position: relative;\r\n}\r\n\r\n    .dropdown-submenu > .dropdown-menu {\r\n        -moz-border-radius: 0 6px 6px 6px;\r\n        -webkit-border-radius: 0 6px 6px 6px;\r\n        border-radius: 0 6px 6px 6px;\r\n        left: 100%;\r\n        margin-left: -1px;\r\n        margin-top: -6px;\r\n        top: 0;\r\n    }\r\n\r\n    .dropdown-submenu:hover > .dropdown-menu {\r\n        display: block;\r\n    }\r\n\r\n    .dropdown-submenu > a:after {\r\n        border-color: transparent;\r\n        border-left-color: #cccccc;\r\n        border-style: solid;\r\n        border-width: 5px 0 5px 5px;\r\n        content: \" \";\r\n        display: block;\r\n        float: right;\r\n        height: 0;\r\n        margin-right: -10px;\r\n        margin-top: 5px;\r\n        width: 0;\r\n    }\r\n\r\n    .dropdown-submenu:hover > a:after {\r\n        border-left-color: #ffffff;\r\n    }\r\n\r\n    .dropdown-submenu.pull-left {\r\n        float: none;\r\n    }\r\n\r\n        .dropdown-submenu.pull-left > .dropdown-menu {\r\n            -moz-border-radius: 6px 0 6px 6px;\r\n            -webkit-border-radius: 6px 0 6px 6px;\r\n            border-radius: 6px 0 6px 6px;\r\n            left: -100%;\r\n            margin-left: 10px;\r\n        }\r\n\r\n.input-group.date {\r\n    display: inline-block\r\n}\r\n\r\n.glyphicon-calendar {\r\n    left: -6px;\r\n    top: -1px;\r\n}\r\n\r\n.date .input-group-addon {\r\n    float: right;\r\n    height: 26px;\r\n    margin: 0px 30px 0 -40px;\r\n    position: relative\r\n}\r\n\r\ntd.acoes-itens {\r\n    border: 0;\r\n    width: 20px;\r\n    font-size: 11px;\r\n}\r\n\r\n.sidebar.sidebar-default .sidebar-item > a:hover, .sidebar.sidebar-default .sidebar-item > a:focus {\r\n    color: var(--mu-primaria-texto, #409fff) !important;\r\n}\r\n\r\n/* --- Barra do controle de tema no rodape do drawer (MenuPrincipal.tsx) ----\r\n   Ela e `position: absolute` ancorada em `.sidebar` (que e `position: fixed`),\r\n   logo NAO rola junto com a lista — fica parada no rodape enquanto os itens\r\n   passam por baixo. Em tela baixa isso fazia os ultimos itens (\"Desdobramento\",\r\n   \"Ordem de Producao\") aparecerem por tras do rotulo \"Tema Escuro\".\r\n\r\n   Duas coisas resolvem, e as duas sao necessarias:\r\n     1. fundo OPACO ocupando a largura toda, para esconder o que passa atras;\r\n     2. `padding-bottom` na lista rolavel (regra seguinte), do tamanho da barra,\r\n        para o ultimo item continuar alcancavel em vez de ficar preso embaixo. */\r\n.menu-principal-barra-tema {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    padding: 8px 10px;\r\n    background-color: var(--mu-drawer-fundo, #fff);\r\n    border-top: 1px solid var(--mu-borda-sutil, #eee);\r\n}\r\n\r\n/* `.sidebar-menu` e quem rola (`overflow-y: auto` vem do CSS do sonatra). */\r\n.sidebar.sidebar-ready .sidebar-menu {\r\n    padding-bottom: 52px;\r\n}\r\n\r\n#menu-esquerdo {\r\n    border-right: 1px solid var(--mu-borda-sutil, #e5e5e5);\r\n}\r\n\r\n.sidebar-collapse .btn-pin {\r\n    width: 50px;\r\n}\r\n\r\n.ps-title {\r\n    font-size: 14px;\r\n    color: var(--mu-texto, black);\r\n    letter-spacing: 2px;\r\n    text-transform: uppercase;\r\n    line-height: 24px;\r\n    margin-top: 5px;\r\n}\r\n\r\n\r\n.wrapword {\r\n    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */\r\n    white-space: -pre-wrap; /* Opera 4-6 */\r\n    white-space: -o-pre-wrap; /* Opera 7 */\r\n    white-space: pre-wrap; /* css-3 */\r\n    word-wrap: break-word; /* Internet Explorer 5.5+ */\r\n    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/\r\n    word-break: wrapword;\r\n    white-space: normal;\r\n}\r\n\r\nth > .open > .dropdown-menu {\r\n    overflow-y: auto;\r\n    height: 250px;\r\n}\r\n\r\n\r\n\r\n.aviso-processing {\r\n    position: fixed;\r\n    cursor: progress;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(51, 51, 51, 0.7);\r\n    color: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    min-width: 300px;\r\n    max-width: 80%;\r\n    box-shadow: 0 4px 20px rgba(0,0,0,0.3);\r\n    z-index: 9999;\r\n    overflow: hidden;\r\n    backdrop-filter: blur(2px);\r\n}\r\n\r\n.aviso-content {\r\n    cursor: progress;\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n.aviso-title {\r\n    cursor: progress;\r\n    font-weight: bold;\r\n    font-size: 1.2em;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.aviso-message {\r\n    cursor: progress;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.aviso-border-animation {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 4px;\r\n    background: linear-gradient(90deg, blue 0%, var(--mu-superficie, rgb(255, 255, 255)) 100%);\r\n    background-size: 200% 100%;\r\n    animation: borderFlow 2s linear infinite;\r\n}\r\n\r\n@keyframes borderFlow {\r\n    0% {\r\n        background-position: 200% 0;\r\n    }\r\n\r\n    100% {\r\n        background-position: -200% 0;\r\n    }\r\n}\r\n\r\n.screen-block-overlay__icone-processando {\r\n    width: 64px;\r\n    height: 64px;\r\n    overflow: hidden;\r\n    cursor: wait;\r\n    -webkit-mask-image: url(images/logo-microuniverso-icone.svg);\r\n    mask-image: url(images/logo-microuniverso-icone.svg);\r\n    -webkit-mask-size: contain;\r\n    mask-size: contain;\r\n    -webkit-mask-repeat: no-repeat;\r\n    mask-repeat: no-repeat;\r\n    -webkit-mask-position: center;\r\n    mask-position: center;\r\n}\r\n\r\n.screen-block-overlay__icone-processando-gradiente {\r\n    width: 100%;\r\n    height: 100%;\r\n    background: conic-gradient(from 0deg,\r\n        #12627D 0%,\r\n        #3AA8D8 15%,\r\n        #A6E3F7 30%,\r\n        #3AA8D8 45%,\r\n        #12627D 60%,\r\n        #12627D 100%);\r\n    animation: girarCorIconeProcessando 1.6s linear infinite;\r\n}\r\n\r\n@keyframes girarCorIconeProcessando {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.botao-flutuante-cesta-produtos {\r\n    position: fixed;\r\n    right: 24px;\r\n    bottom: 24px;\r\n    z-index: 1040;\r\n    width: 56px;\r\n    height: 56px;\r\n    box-sizing: border-box;\r\n    /* border: 3px solid rgba(0, 0, 0, 0.15);*/\r\n    border-radius: 50%; \r\n    background-color: var(--mu-primaria, #409fff);\r\n    color: #fff;\r\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.55), 0 3px 8px rgba(0, 0, 0, 0.45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    -webkit-transition: right 0.3s ease-in-out;\r\n    -o-transition: right 0.3s ease-in-out;\r\n    transition: right 0.3s ease-in-out;\r\n}\r\n\r\n.botao-flutuante-cesta-produtos:hover:not(:disabled) {\r\n    filter: brightness(0.92);\r\n}\r\n\r\n.botao-flutuante-cesta-produtos:active:not(:disabled) {\r\n    filter: brightness(0.82);\r\n}\r\n\r\n.botao-flutuante-cesta-produtos .material-symbols-rounded {\r\n    font-size: 28px;\r\n}\r\n\r\n.badge-flutuante-cesta-produtos {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -4px;\r\n    min-width: 20px;\r\n    height: 20px;\r\n    padding: 0 5px;\r\n    border-radius: 10px;\r\n    background-color: #e53935;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    line-height: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n@keyframes botaoFlutuanteCestaProdutosPop {\r\n    0% {\r\n        transform: scale(1);\r\n    }\r\n\r\n    30% {\r\n        transform: scale(1.18);\r\n    }\r\n\r\n    60% {\r\n        transform: scale(0.94);\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.botao-flutuante-cesta-produtos--animando {\r\n    animation: botaoFlutuanteCestaProdutosPop 0.9s ease-in-out;\r\n}\r\n\r\n/* 491123 — badge de \"produto já adicionado\" sobre o ícone local_mall de cada linha da grid de\r\n   pesquisa de produtos (itemPesquisaProduto_BadgeLocalMall_*). Círculo sólido com um check branco\r\n   centralizado, pendurado no canto inferior direito da sacola (desenho do mockup da ficha).\r\n   Posicionado relativo ao <button> do ícone, que tem position:relative inline (ver\r\n   ItemPesquisaProduto.tsx) — o wrapper \"_relative\" externo ancora o dropdown, não o badge.\r\n   Offsets NEGATIVOS deixam o centro do círculo praticamente sobre o canto da sacola, em vez de\r\n   encostado no traço; por isso não há anel branco separando os dois. O <button> não tem\r\n   overflow:hidden (ver botoes.module.scss .botaoIcone), então o transbordo aparece normalmente.\r\n   Mora aqui (CSS global) e não num .module.scss por escolha do autor da ficha. */\r\n.badge-local-mall {\r\n    position: absolute;\r\n    bottom: -1px;\r\n    right: -2px;\r\n    box-sizing: border-box;\r\n    width: 18px;\r\n    height: 18px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    color: #fff;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Diferente de um .module.scss, aqui o seletor descendente com a classe GLOBAL\r\n   .material-symbols-rounded funciona: neste arquivo nada é hasheado por CSS Modules\r\n   (ver APRENDIZADOS #253, que é justamente o caso oposto). wght maior mantém o traço do\r\n   check legível nesse tamanho; FILL 0 segue o padrão de ícones do projeto (#210). */\r\n.badge-local-mall .material-symbols-rounded {\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    font-variation-settings: 'FILL' 0, 'wght' 700, 'GRAD' 0, 'opsz' 20;\r\n}\r\n\r\n/* Produto apenas na cesta — mesmo azul dos ícones de ação do app (base.$cor-icone no SCSS),\r\n   para o badge combinar com o traço da sacola por baixo. */\r\n.badge-local-mall--azul {\r\n    background-color: #1584e0;\r\n}\r\n\r\n/* Produto já existe no orçamento — mesmo verde usado como convenção de \"concluído\"/\"configurado\"\r\n   no projeto (ver botaoTintaVerde em ItemPesquisaProduto.module.scss). */\r\n.badge-local-mall--verde {\r\n    background-color: #2E978C;\r\n}\r\n\r\n/* ==========================================================================\r\n   Toastr — deixar a FAIXA do container transparente a cliques\r\n   ==========================================================================\r\n   globalMU.showMessage usa positionClass \"toast-top-center\", e o toastr.css\r\n   vendorizado define:\r\n\r\n       .toast-top-center { top: 0; right: 0; width: 100%; }\r\n       #toast-container  { position: fixed; z-index: 999999; }\r\n\r\n   Ou seja: o container é uma faixa fixa de LARGURA TOTAL no topo da página, com\r\n   z-index 999999 — mesmo que o toast visível dentro dele tenha só 300px e fique\r\n   centralizado (#toast-container.toast-top-center > div { width: 300px; margin: auto }).\r\n   Como a faixa inteira captura eventos de ponteiro, tudo que fica embaixo dela\r\n   (menu hambúrguer à esquerda, nome/avatar do usuário à direita, abas) ficava\r\n   inclicável enquanto o toast estava na tela.\r\n\r\n   Correção: a faixa não recebe eventos (os cliques atravessam para o que está\r\n   atrás) e os toasts em si voltam a receber — preservando o botão de fechar (×),\r\n   o clique-para-dispensar e o :hover que segura o timeout.\r\n\r\n   Este arquivo entra pelo main-app.js, que é requerido DEPOIS do main-vendor.js\r\n   (dono do toastr.css) em main.js — então, com a mesma especificidade de ID, o\r\n   override daqui ganha no cascade sem precisar de !important nem de editar o\r\n   arquivo vendorizado em assets/toastr/. */\r\n#toast-container {\r\n    pointer-events: none;\r\n}\r\n\r\n#toast-container > div,\r\n#toast-container > .toast {\r\n    pointer-events: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
